import { GlobalServices } from 'src/app/shared/services/global.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../../../../app/shared/components/alert/alert.service';
import { fileService } from '../../../../../app/front-user/shared/services/file.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { ReleaseWFSubmittedAdminsRoles, Logo, SCAWaterMark, AttachmentType,RestudyEconomicManagerDecision } from 'src/app/shared/models/enums.model';
import { LongHaulRequestConfirmShipPassing, LongHaulRequestOptionFormulatedDecision, Stoppage, ReleaseOpject, LongHaulRequestOption, LongHaulRequestFormulateDecision, Diff, OptionKey, ReleaseFormStartWFDTO, ReleaseRefundRequestDTO, ReleaseRestudyRequestDTO, ReleaseFormAttachment ,ArabicNames } from 'src/app/shared/models/long-haul.model';
import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output, ChangeDetectorRef, ViewEncapsulation, Input } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { VesselType } from 'src/app/front-user/shared/models/vessel-type.modal';
import { FileValidator } from '../../../../../app/front-user/shared/validator/file-input.validator';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { PortalUserService } from 'src/app/front-user/services/e-booking/shared/services/portal-user.service';
import { ETendersCategoriesAdminDTO } from 'src/app/shared/models/e-tender.model';
import { Port } from 'src/app/front-user/shared/models/port.model';
import { EMAIL_NAME_MAP } from 'src/app/arabic-names';
import { AppConfig } from 'src/app/shared/services/app.config';
import { MembershipService } from 'src/app/front-user/services/e-booking/shared/services/membership.service';
import { DatePipe } from '@angular/common';
import { ReleaseWFSubmittedAdminsDTO } from 'src/app/shared/models/long-haul.model';
import { Service, ServiceStatus, TernaryDecision } from 'src/app/shared/models/enums.model';
import * as pdfMake from 'pdfmake/build/pdfmake.min';
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

@Component({

  selector: 'app-rebate-requests-release-form',
  templateUrl: './release-form-component.html',
  encapsulation: ViewEncapsulation.None,
})

export class ReleaseFormComponent implements OnInit {
  public currentUser: User = new User();

  showDelete: boolean = true;
  DocsAttachmentType = AttachmentType.ReleaseFormDocs;
  AISAttachmentType = AttachmentType.ReleaseFormAIS;
  currenctDocAttachment: ReleaseFormAttachment = new ReleaseFormAttachment();
  currenctAISAttachment: ReleaseFormAttachment = new ReleaseFormAttachment();
  getAttachments: ReleaseFormAttachment[] = [];
  uploadUrl = AppConfig.settings.apiServer.UploadsUrl;
  uploadFolder = AppConfig.settings.apiServer.ReleaseUploadsFolder;
  Transitagent: string = "";
  private RequestorId: string = "";
  ReleaseFormId: string = "";
  isRestudy: boolean = true;
  newReleaseForm: boolean = false;
  showUpload:boolean = true;
  showPDF: boolean = false;
  private selectedoption: any;
  private submitReleaseRequestResponseObject: ResponseObject = new ResponseObject();
  private startWFObject: ResponseObject = new ResponseObject();
  private getConfirmShipPassingObjectResponseObject: ResponseObject = new ResponseObject();
  private confirmShipPassingRequest: LongHaulRequestConfirmShipPassing = new LongHaulRequestConfirmShipPassing();
  private releaseFormStart: ReleaseFormStartWFDTO = new ReleaseFormStartWFDTO();
  AgentCurrencies: GenericLookup[] = [];
  selectedEmails: [] = [];
  AdminEmail: string = "";
  showCircularName: boolean = false;
  showExceptionNote: boolean = false;
  Actualvoyage: string = "";
  showInfo: boolean = false;
  isRestudy_RestudyRequireModifications: boolean = false;
  showTabSix: boolean = false;
  showTransitagentText: boolean = false;
  AdminId: string = "";
  ListOfAdmins: ETendersCategoriesAdminDTO[];
  private showML: boolean = false;
  public isMoreInfo: boolean = false;
  public AttachmentView: boolean = false;
  private isSubmitEnabled: boolean = false;
  private showNotes: boolean = false;
  public isCalculated = false;
  private selectedWF = "";
  ConfirmShipPassingTransitdate: Date;
  TransitagentFax: string = "";
  TransitagentEmail: string = "";
  TransitagentId: string = "";
  private savedID: string = "";
  private confirmationMessage: string = "";
  private relaseRequestObject;
  autoCompleteMinQueryLength: number = 3;
  isTabOneSubmitted: boolean = false;
  isAutoCompleteLoading: Boolean
  isTabTwoSubmitted: boolean = false;
  isSubmitButtonDisplayed: boolean = false;
  isWFSubmitButtonDisplayed: boolean = false;
  isRefundWorkflow: boolean = false;
  isRestudyWorkflow: boolean = false;
  showAddAISVoyageStoppage: boolean = true;
  showAddVoyageStoppage: boolean = true;
  showAddAttachment: boolean = true;
  showValidateBtn: boolean = true;
  numberRegex: any = /^[0-9]*$/;
  showReasonCol: boolean = true;
  showSubmitWorkflowBtn: boolean = false;
  showMoreInformationMessage: boolean = false;
  showSaveBtn: boolean = false;
  showdeleteVoyage: boolean = false;
  moreInfoMessage: string = "";
  isTabFiveSubmitted: boolean = false;
  isTabThreeSubmitted: boolean = false;
  isTabFourSubmitted: boolean = false;
  Error: boolean = false;
  selectedRows: any[] = [];
  private requestStoppage: Stoppage[] = [];
  private requestAttachments: ReleaseFormAttachment[] = [];
  private AISAttachment: ReleaseFormAttachment[] = [];
  private DocsAttachment: ReleaseFormAttachment[] = [];
  private CertificatesStoppage: Stoppage[] = [];
  private AISStoppage: Stoppage[] = [];
  public vesselTypes: GenericLookup[] = [];
  public circulars: GenericLookup[] = [];
  public arabicNames: ArabicNames[] = [];
  public diffsObjects: Diff[] = [];
  private getRequestRequestorDecisionResponseObject: ResponseObject = new ResponseObject();
  public rebateRequestLoaded: ReleaseOpject = new ReleaseOpject();
  private longHaulRequestRequestorDecisionRequest: LongHaulRequestFormulateDecision = new LongHaulRequestFormulateDecision();
  private longHaulRequestRequestorDecisionResponse: LongHaulRequestFormulateDecision = new LongHaulRequestFormulateDecision();
  @Output() rebateRequestLoadedFlag: EventEmitter<boolean> = new EventEmitter();
  // @Input() public Request: string = "";
  isOpenedFromLonghaulReport: boolean = false;
  @Input() public isShow: boolean = true;
  @Input() public isRealseForm: boolean = true;
  @Input() public isOpenedFromReleaseReport: boolean = false;
  private rebateRequestId: string = "";
  refundRequestId: string = "";
  restudyRequestId: string = "";
  private showReason: boolean = false;
  private releaseFromId: string = "";
  public releaseRequestForm: FormGroup;
  public initiateworkflowForm: FormGroup;
  public noteAndReasons: FormGroup;
  public WorkflowActionForm: FormGroup;
  public ReleaseFormDecisionNote: FormGroup;
  private selectedRate: any;
  private selectedvesselType: any;
  private selectedCircular: any;

  @ViewChild('rebateRequestTabs', { static: false }) rebateRequestTabs: TabsetComponent;
  @ViewChild('releaseRequest', { static: false }) releaseRequestEle: ElementRef;
  @ViewChild('tabOne', { static: false }) tabOne: ElementRef;
  @ViewChild('TabTwo', { static: false }) TabTwo: ElementRef;
  @ViewChild('TabThree', { static: false }) TabThree: ElementRef;
  @ViewChild('TabFour', { static: false }) TabFour: ElementRef;
  @ViewChild('TabFourStoppage', { static: false }) TabFourStoppage: ElementRef;
  @ViewChild('TabFourAttachments', { static: false }) TabFourAttachments: ElementRef;
  @ViewChild('TabFiveStoppage', { static: false }) TabFiveStoppage: ElementRef;
  @ViewChild('TabFive', { static: false }) TabFive: ElementRef;
  @ViewChild('TabSix', { static: false }) TabSix: ElementRef;
  responseObject: ResponseObject;
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  public longHaulRequestOptions: LongHaulRequestOption[] = [];
  private lastPortOriginsArr: OptionKey[] = [];
  agentsNamesList = [];
  currentRoute: string = '';
  public formMode: FormMode = FormMode.New;
  public isFormValid: boolean = false;
  agentsData = [];
  LongHaulRequestOptionsFormulatedDecision = [];
  private ports: Port[] = [];
  private isSave: boolean = false;
  private isFormSubmitted: boolean = false;
  public isSubmitted: boolean = false;
  private firstPortDestinationsArr: OptionKey[] = [];
  private getRebateRequestResponseObject: ResponseObject = new ResponseObject();
  private getReleaseFormResponseObject: ResponseObject = new ResponseObject();
  private rates: GenericLookup[] = [];
  public currentSelctedOption: string = null;
  public role: string = "";
  adminsDropdownSettings = {};
  refundResponseObj: ResponseObject;
  restudyResponseObj: ResponseObject;
  refundRequestStatus: any;
  restudyRequestStatus: any;

  refundRequestObj: ReleaseRefundRequestDTO;
  restudyRequestObj: ReleaseRestudyRequestDTO;
  refundwfSignedAdmins: ReleaseWFSubmittedAdminsDTO[] = [];
  refundmeasureItems: ReleaseWFSubmittedAdminsDTO[];
  refundeunitItems: ReleaseWFSubmittedAdminsDTO[];
  refundmanagersItems: ReleaseWFSubmittedAdminsDTO[];


  restudyfSignedAdmins: ReleaseWFSubmittedAdminsDTO[] = [];
  restudymeasureItems: ReleaseWFSubmittedAdminsDTO[];
  restudyeunitItems: ReleaseWFSubmittedAdminsDTO[];
  restudymanagersItems: ReleaseWFSubmittedAdminsDTO[];


  constructor(private alertService: AlertService, private fileService: fileService, private portalSrv: PortalUserService, private membershipService: MembershipService, private translate: TranslateService, private router: Router, private route: ActivatedRoute, private toastr: ToastrService, private datePipe: DatePipe, private cd: ChangeDetectorRef, private agentSrv: AgentService, private lookupService: LookupService, private formBuilder: FormBuilder, private etenderSrv: EtenderService, private global: GlobalServices, private globalServices: GlobalServices, private longHaulService: LongHaulService, private authenticationService: AuthenticationService) {
    if (history.state.data && history.state.data.ReleaseFormRequestId && history.state.data.requestId && history.state.data.serviceId == Service.LonghaulRefund) {
      this.releaseFromId = history.state.data.ReleaseFormRequestId;

      this.refundRequestId = history.state.data.requestId;
      this.isRefundWorkflow = true;
    } else if (history.state.data && history.state.data.ReleaseFormRequestId && history.state.data.requestId && history.state.data.serviceId == Service.LonghaulRestudy) {
      this.releaseFromId = history.state.data.ReleaseFormRequestId;
      this.restudyRequestId = history.state.data.requestId;
      this.isRestudyWorkflow = true;
    } else if (history.state.data && history.state.data.requestId) {
      this.rebateRequestId = history.state.data.requestId;
      this.isOpenedFromLonghaulReport = true;
    } else {
      window.history.back();
    }
    this.currentUser = this.authenticationService.currentUserValue;
    this.AdminEmail = this.currentUser.Email;
    this.AdminId = this.currentUser.UserId;
    window.scrollTo(0, 300);
    this.adminsDropdownSettings = {
      singleSelection: false,
      idField: 'Email',
      textField: 'Username',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      enableCheckAll: true
    };

  }

  ngOnInit() {
    debugger;
    this.currentRoute = this.route.snapshot.routeConfig?.path || '';
    if (
      this.currentRoute === "RestudyEconomicApproval" ||
      this.currentRoute === "RestudyEconomicManagerApproval" ||
      this.currentRoute === "RefundEunitApproval" ||
      this.currentRoute === "RefundRequest" ||
      this.currentRoute === "RestudyRequest"
    ) {
      this.showTabSix = true;
    }
    else {
      this.showTabSix = false;
    }

    this.globalServices.isLoaderEnabled = true;
    this.buildForm();
    this.loadPorts();
    this.loadCirculars();
    this.GetArabicNames();

  }
  getNameByEmail(email: string): string | undefined {
    let x =  this.arabicNames.find(person => person.Email === email);
    return x.NameAR;
  }
  getReleaseRefundWFSubmittedAdmins() {
    // Call the service to get the release workflow submitted admins
    this.longHaulService.getReleaseWFSubmittedAdmins(this.rebateRequestLoaded.ReleaseRefundRequestId, this.role).subscribe((response: any) => {
      this.refundwfSignedAdmins = response.Data as ReleaseWFSubmittedAdminsDTO[];
      this.refundmeasureItems = this.refundwfSignedAdmins.filter(item => item.Role === ReleaseWFSubmittedAdminsRoles.MeasurementAdmin);
      this.refundeunitItems = this.refundwfSignedAdmins.filter(item => item.Role === ReleaseWFSubmittedAdminsRoles.EunitAdmin);
      this.refundmanagersItems = this.refundwfSignedAdmins.filter(item => item.Role === ReleaseWFSubmittedAdminsRoles.DeputyManager || item.Role === ReleaseWFSubmittedAdminsRoles.Manager);
    });
  }

  getReleaseRestudyWFSubmittedAdmins() {
    // Call the service to get the release workflow submitted admins
    this.longHaulService.getReleaseWFSubmittedAdmins(this.rebateRequestLoaded.ReleaseRestudyRequestId, this.role).subscribe((response: any) => {
      this.restudyfSignedAdmins = response.Data as ReleaseWFSubmittedAdminsDTO[];
      this.restudymeasureItems = this.restudyfSignedAdmins.filter(item => item.Role === ReleaseWFSubmittedAdminsRoles.MeasurementAdmin);
      this.restudyeunitItems = this.restudyfSignedAdmins.filter(item => item.Role === ReleaseWFSubmittedAdminsRoles.EunitAdmin);
      this.restudymanagersItems = this.restudyfSignedAdmins.filter(item => item.Role === ReleaseWFSubmittedAdminsRoles.DeputyManager || item.Role === ReleaseWFSubmittedAdminsRoles.Manager);
    });
  }
  getReleaseForm(): void {
    //When load the release form as a child in Refund/Restudy workflow steps, we pass the release form id  and not longhaul request id
    let id;
    if (this.rebateRequestId == "") {
      id = this.releaseFromId;
    } else {
      id = this.rebateRequestId;
    }
    this.longHaulService.GetReleaseForm(id).subscribe(
      data => this.getReleaseFormResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getReleaseFormCompleted()
    );
  }
  getReleaseFormCompleted(): void {

    if (this.getReleaseFormResponseObject.Success) {

      this.rebateRequestLoaded = this.getReleaseFormResponseObject.Data as ReleaseOpject;
      if (this.rebateRequestLoaded != null) {
        if (this.rebateRequestLoaded.IsCircular) {
          this.showCircularName = true;
        }
        else {
          this.showCircularName = false;
        }
        if (this.rebateRequestLoaded.IsException) {
          this.showExceptionNote = true;
        }
        else {
          this.showExceptionNote = false;
        }
        this.getAgent(this.rebateRequestLoaded.Transitagent);
        //this.showCircularName = false;
        this.longHaulRequestOptions = this.rebateRequestLoaded.LongHaulRequestOptions;

        this.fillPortsDictionary();
        this.showSaveBtn = true;
        this.savedID = this.rebateRequestLoaded.Id;

        this.TransitagentFax = this.rebateRequestLoaded.TransitagentFax;
        this.RequestorId = this.rebateRequestLoaded.RequestorId;
        this.getReleaseRefundWFSubmittedAdmins();
        this.getReleaseRestudyWFSubmittedAdmins();

        this.getRebateRequestOptions();


        if (this.rebateRequestLoaded.ReleaseFormAttachment.length > 0) {
          this.rebateRequestLoaded.ReleaseFormAttachment.forEach(element => {
            if (element.AttachmentTypeId == 41) {
              this.DocsAttachment.push(element);


            }
            else {
              this.AISAttachment.push(element);


            }

          });
          this.bindAisAttachments(this.AISAttachment);
          this.bindDocsAttachments(this.DocsAttachment);
        }
        else
        {
          this.AttachmentView = false;
          this.showDelete = true;
        }

        if (this.rebateRequestLoaded.Stoppages.length > 0) {

          this.rebateRequestLoaded.Stoppages.forEach(element => {
            if (element.TYPE == 'Certificates') {
              this.CertificatesStoppage.push(element);
              let VoyageStoppageDetailscontrol;
              VoyageStoppageDetailscontrol = <FormArray>this.releaseRequestForm.controls['TabFour'];

            }
            else {
              this.AISStoppage.push(element);
              let AISVoyageStoppageDetailscontrol;
              AISVoyageStoppageDetailscontrol = <FormArray>this.releaseRequestForm.controls['TabFive'];

            }

          });

          this.CertificatesStoppage.sort((a, b) => new Date(a.StartDate).getTime() - new Date(b.StartDate).getTime());
          this.AISStoppage.sort((a, b) => new Date(a.StartDate).getTime() - new Date(b.StartDate).getTime());

          this.bindStoppageDetails(this.AISStoppage, "AISVoyageStoppageDetails");
          this.bindStoppageDetails(this.CertificatesStoppage, "VoyageStoppageDetails");
        }
        if (this.rebateRequestLoaded.ReleaseRefundRequestId != null && this.rebateRequestLoaded.ReleaseRefundRequestId != "") {
          this.refundRequestId = this.rebateRequestLoaded.ReleaseRefundRequestId;
          this.isRefundWorkflow = true;
        }
        if (this.rebateRequestLoaded.ReleaseRestudyRequestId != null && this.rebateRequestLoaded.ReleaseRestudyRequestId != "") {
          this.restudyRequestId = this.rebateRequestLoaded.ReleaseRestudyRequestId;
          this.isRestudyWorkflow = true;
        }
        if (this.isRefundWorkflow) {
          this.getRefundRequest(this.refundRequestId);
        }
        if (this.isRestudyWorkflow) {
          this.getRestudyRequest(this.restudyRequestId);
        }
        this.globalServices.isLoaderEnabled = false;
        this.rebateRequestLoadedFlag.emit(true);
        this.toastr.clear();
        window.scrollTo(0, 490);
        if (!this.isRefundWorkflow && !this.isRestudyWorkflow) {
          this.toastr.success('Release Form Data!', 'Success!');
          this.formMode == FormMode.Edit;
          this.showdeleteVoyage = true;
        }
      }
      else {
        this.showSaveBtn = true;
        this.showdeleteVoyage = true;
        this.getRebateRequest()
      }
    }
    else {
      this.getRebateRequest()
    }
  }
  bindStoppageDetails(Stoppages, controlName): any {


    if (controlName == 'VoyageStoppageDetails') {
      let control = <FormArray>this.releaseRequestForm.controls['TabFour'].get('VoyageStoppageDetails');
      Stoppages.forEach((key) => {
        control.push(new FormGroup({
          StoppagePortName: new FormControl({ value: key.PortName, disabled: false }),
          StoppageReason: new FormControl({ value: key.Reason, disabled: false }),
          StoppageStartDate: new FormControl({ value: this.datePipe.transform(key.StartDate, "yyyy-MM-dd"), disabled: false }),
          StoppageEndDate: new FormControl({ value: this.datePipe.transform(key.EndDate, "yyyy-MM-dd"), disabled: false }),
          Id: new FormControl({ value: key.Id, disabled: false }),
        }));
      });
      return control;
    }
    else {


      let control = <FormArray>this.releaseRequestForm.controls['TabFive'].get('AISVoyageStoppageDetails');
      Stoppages.forEach((key) => {
        control.push(new FormGroup({
          AISStoppagePortName: new FormControl({ value: key.PortName, disabled: false }),
          AISStoppageStartDate: new FormControl({ value: this.datePipe.transform(key.StartDate, "yyyy-MM-dd"), disabled: false }),
          AISStoppageEndDate: new FormControl({ value: this.datePipe.transform(key.EndDate, "yyyy-MM-dd"), disabled: false }),
          Id: new FormControl({ value: key.Id, disabled: false }),
        }));
      });
      return control;
    }

  }
  onIsCircularChange(value: string): void {
    if (value == "true") {
      this.showCircularName = true;
      (this.releaseRequestForm.controls['TabThree'] as FormGroup).controls['CircularName'].setValidators([Validators.required]);
      (this.releaseRequestForm.controls['TabThree'] as FormGroup).controls['CircularName'].updateValueAndValidity();
    }
    else {
      this.showCircularName = false;
      (this.releaseRequestForm.controls['TabThree'] as FormGroup).controls['CircularName'].reset();
      (this.releaseRequestForm.controls['TabThree'] as FormGroup).controls['CircularName'].clearValidators();
      (this.releaseRequestForm.controls['TabThree'] as FormGroup).controls['CircularName'].updateValueAndValidity();
    }
  }


  onIsExceptionChange(value: string): void {
    if (value == "true") {
      this.showExceptionNote = true;
      (this.releaseRequestForm.controls['TabThree'] as FormGroup).controls['ExceptionNote'].setValidators([Validators.required]);
      (this.releaseRequestForm.controls['TabThree'] as FormGroup).controls['ExceptionNote'].updateValueAndValidity();
    }
    else {
      this.showExceptionNote = false;
      (this.releaseRequestForm.controls['TabThree'] as FormGroup).controls['ExceptionNote'].reset();
      (this.releaseRequestForm.controls['TabThree'] as FormGroup).controls['ExceptionNote'].clearValidators();
      (this.releaseRequestForm.controls['TabThree'] as FormGroup).controls['ExceptionNote'].updateValueAndValidity();
    }
  }

  getRebateRequest(): void {
    this.longHaulService.GetReleaseFormData(this.rebateRequestId).subscribe(
      data => this.getRebateRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getRebateRequestCompleted()
    );
  }
  getRebateRequestCompleted(): void {
    if (this.getRebateRequestResponseObject.Success) {
      this.formMode == FormMode.New;
      this.rebateRequestLoaded = this.getRebateRequestResponseObject.Data as ReleaseOpject;
      this.longHaulRequestOptions = this.rebateRequestLoaded.LongHaulRequestOptions;
      this.fillPortsDictionary();
      this.RequestorId = this.rebateRequestLoaded.RequestorId;
      this.getRebateRequestOptions();
      this.getConfirmShipPassingObject();
      this.getAgent(this.rebateRequestLoaded.Transitagent);
      this.fillForm();
      this.toastr.clear();
      window.scrollTo(0, 490);
      this.newReleaseForm = true;
      this.toastr.success('New Release Form!', 'Success!');

      this.globalServices.isLoaderEnabled = false;
      this.rebateRequestLoadedFlag.emit(true);
      this.releaseRequestForm.controls['TabThree'].patchValue({
        Transitagent: "",

      })
    }
    else {

      this.isFormValid = true;
      this.Error = true;
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.globalServices.isLoaderEnabled = false;
    }
  }

  getRefundRequest(baseRequestId: string): void {
    this.longHaulService.GetRefundRequestById(baseRequestId).subscribe(
      (resObj: ResponseObject) => {
        this.refundResponseObj = resObj;
        if (this.refundResponseObj.Success) {
          this.refundRequestObj = this.refundResponseObj.Data;
          this.refundRequestStatus = this.refundRequestObj.BaseRequest.StatusId;
          if (this.refundRequestStatus != ServiceStatus.Refund_RefundRequireModifications) {
            this.showValidateBtn = false;
            this.showInfo = true;
            this.showdeleteVoyage = false;
            this.AttachmentView = true;

            this.formMode == FormMode.Details;
            this.showAddAISVoyageStoppage = false;
            this.showAddVoyageStoppage = false;
            this.showAddAttachment = false;
            this.releaseRequestForm.disable();
            this.showUpload= false;
          } else if (this.isOpenedFromReleaseReport || this.isOpenedFromLonghaulReport) {
            this.showValidateBtn = false;
            this.showInfo = true;
            this.showdeleteVoyage = false;
            this.AttachmentView = true;

            this.formMode == FormMode.Details;
            this.showAddAISVoyageStoppage = false;
            this.showAddAttachment = false;
            this.showAddVoyageStoppage = false;
            this.releaseRequestForm.disable();
            this.showUpload= false;

          } else {
            this.isMoreInfo = true;
            //this.showCircularName = true;
            (this.releaseRequestForm.controls['TabThree'] as FormGroup).controls['CircularName'].setValidators([Validators.required]);
            (this.releaseRequestForm.controls['TabThree'] as FormGroup).controls['CircularName'].updateValueAndValidity();
            this.isSubmitButtonDisplayed = false;
            this.showMoreInformationMessage = true;
            this.showSaveBtn = false;
            this.showdeleteVoyage = false;
            if (this.refundRequestObj.MeasReviewer1Decision == TernaryDecision.RequiredModifications && this.refundRequestObj.MeasReviewer1Notes != null) {
              this.moreInfoMessage = this.refundRequestObj.MeasReviewer1Notes;
            } else if (this.refundRequestObj.MeasReviewer2Decision == TernaryDecision.RequiredModifications && this.refundRequestObj.MeasReviewer2Notes != null) {
              this.moreInfoMessage = this.refundRequestObj.MeasReviewer2Notes;
            } else if (this.refundRequestObj.MeasManagerDecision == TernaryDecision.RequiredModifications && this.refundRequestObj.MeasManagerNotes != null) {
              this.moreInfoMessage = this.refundRequestObj.MeasManagerNotes;
            } else if (this.refundRequestObj.EunitDecision == TernaryDecision.RequiredModifications && this.refundRequestObj.EunitNotes != null) {
              this.moreInfoMessage = this.refundRequestObj.EunitNotes;
            }
          }
        }
      });
  }

  getRestudyRequest(baseRequestId: string): void {
    // TODO
    this.longHaulService.GetRestudyRequestById(baseRequestId).subscribe(
      (resObj: ResponseObject) => {
        this.restudyResponseObj = resObj;

        if (this.restudyResponseObj.Success) {
          this.restudyRequestObj = this.restudyResponseObj.Data;
          this.restudyRequestStatus = this.restudyRequestObj.BaseRequest.StatusId;
          this.showReason = true;
          if (this.restudyRequestStatus == ServiceStatus.Restudy_RestudyRequireModifications) {
            this.isRestudy_RestudyRequireModifications = true;
          }
          if (this.restudyRequestStatus != ServiceStatus.Restudy_RestudyRequireModifications) {
            this.showValidateBtn = false;
            this.showdeleteVoyage = false;
            this.AttachmentView = true;

            this.formMode == FormMode.Details;
            this.showAddAISVoyageStoppage = false;
            this.showAddVoyageStoppage = false;
            this.showAddAttachment = false;
            this.showInfo = true;
            this.releaseRequestForm.disable();
            this.showUpload= false;

            this.noteAndReasons.disable();
          } else if (this.isOpenedFromReleaseReport || this.isOpenedFromLonghaulReport) {
            this.showValidateBtn = false;
            this.showdeleteVoyage = false;
            this.formMode == FormMode.Details;
            this.showAddAISVoyageStoppage = false;
            this.showAddVoyageStoppage = false;
            this.showAddAttachment = false;
            this.showInfo = true;
            this.releaseRequestForm.disable();
            this.showUpload= false;

            this.noteAndReasons.disable();
          }
          else {
            this.isSubmitButtonDisplayed = false;
            this.isMoreInfo = true;
            this.showMoreInformationMessage = true;
            this.showSaveBtn = false;
            this.showdeleteVoyage = false;
            if (this.restudyRequestObj.MeasReviewerDecision == TernaryDecision.RequiredModifications && this.restudyRequestObj.MeasReviewerNotes != null) {
              this.moreInfoMessage = this.restudyRequestObj.MeasReviewerNotes;
            } else if (this.restudyRequestObj.MeasReviewer2Decision == TernaryDecision.RequiredModifications && this.restudyRequestObj.MeasReviewer2Notes != null) {
              this.moreInfoMessage = this.restudyRequestObj.MeasReviewer2Notes;
            } else if (this.restudyRequestObj.MeasManagerDecision == TernaryDecision.RequiredModifications && this.restudyRequestObj.MeasManagerNotes != null) {
              this.moreInfoMessage = this.restudyRequestObj.MeasManagerNotes;
            } else if (this.restudyRequestObj.EunitRegistersDecision == TernaryDecision.RequiredModifications && this.restudyRequestObj.EunitRegisterNotes != null) {
              this.moreInfoMessage = this.restudyRequestObj.EunitRegisterNotes;
            }
          }
        }
      });
  }
  numberToArabicWordswithoutCurrency(num: number): string {
    if (isNaN(num)) return 'رقم غير صالح';

    const ones = ['', 'واحد', 'اثنان', 'ثلاثة', 'أربعة', 'خمسة', 'ستة', 'سبعة', 'ثمانية', 'تسعة'];
    const tens = ['', 'عشرة', 'عشرون', 'ثلاثون', 'أربعون', 'خمسون', 'ستون', 'سبعون', 'ثمانون', 'تسعون'];
    const teens = ['أحد عشر', 'اثنا عشر', 'ثلاثة عشر', 'أربعة عشر', 'خمسة عشر', 'ستة عشر', 'سبعة عشر', 'ثمانية عشر', 'تسعة عشر'];
    const hundreds = ['', 'مائة', 'مئتان', 'ثلاثمائة', 'أربعمائة', 'خمسمائة', 'ستمائة', 'سبعمائة', 'ثمانمائة', 'تسعمائة'];

    function underThousand(n: number): string {
      let result = '';

      const h = Math.floor(n / 100);
      const t = Math.floor((n % 100) / 10);
      const o = n % 10;

      if (h > 0) result += hundreds[h];

      if (n % 100 > 10 && n % 100 < 20) {
        if (result) result += ' و ';
        result += teens[n % 100 - 11];
      } else {
        if (o > 0) {
          if (result) result += ' و ';
          result += ones[o];
        }

        if (t > 0) {
          if (result) result += ' و ';
          result += tens[t];
        }
      }

      return result;
    }

    function sectionToWords(n: number, unit: string, dual: string, plural: string): string {
      if (n === 0) return '';
      if (n === 1) return unit;
      if (n === 2) return dual;
      if (n >= 3 && n <= 10) return `${underThousand(n)} ${plural}`;
      return `${underThousand(n)} ${unit}`;
    }

    const parts: string[] = [];

    const billion = Math.floor(num / 1_000_000_000);
    const million = Math.floor((num % 1_000_000_000) / 1_000_000);
    const thousand = Math.floor((num % 1_000_000) / 1000);
    const remainder = Math.floor(num % 1000);

    if (billion) parts.push(sectionToWords(billion, 'مليار', 'ملياران', 'مليارات'));
    if (million) parts.push(sectionToWords(million, 'مليون', 'مليونان', 'ملايين'));
    if (thousand) parts.push(sectionToWords(thousand, 'ألف', 'ألفان', 'آلاف'));
    if (remainder) parts.push(underThousand(remainder));

    const integerWords = parts.join(' و ') || 'صفر';

    return `${integerWords} في المائة `;

  }
  numberToArabicWords(num: number): string {
    if (isNaN(num)) return 'رقم غير صالح';

    const ones = ['', 'واحد', 'اثنان', 'ثلاثة', 'أربعة', 'خمسة', 'ستة', 'سبعة', 'ثمانية', 'تسعة'];
    const tens = ['', 'عشرة', 'عشرون', 'ثلاثون', 'أربعون', 'خمسون', 'ستون', 'سبعون', 'ثمانون', 'تسعون'];
    const teens = ['أحد عشر', 'اثنا عشر', 'ثلاثة عشر', 'أربعة عشر', 'خمسة عشر', 'ستة عشر', 'سبعة عشر', 'ثمانية عشر', 'تسعة عشر'];
    const hundreds = ['', 'مائة', 'مئتان', 'ثلاثمائة', 'أربعمائة', 'خمسمائة', 'ستمائة', 'سبعمائة', 'ثمانمائة', 'تسعمائة'];

    function underThousand(n: number): string {
      let result = '';

      const h = Math.floor(n / 100);
      const t = Math.floor((n % 100) / 10);
      const o = n % 10;

      if (h > 0) result += hundreds[h];

      if (n % 100 > 10 && n % 100 < 20) {
        if (result) result += ' و ';
        result += teens[n % 100 - 11];
      } else {
        if (o > 0) {
          if (result) result += ' و ';
          result += ones[o];
        }

        if (t > 0) {
          if (result) result += ' و ';
          result += tens[t];
        }
      }

      return result;
    }

    function sectionToWords(n: number, unit: string, dual: string, plural: string): string {
      if (n === 0) return '';
      if (n === 1) return unit;
      if (n === 2) return dual;
      if (n >= 3 && n <= 10) return `${underThousand(n)} ${plural}`;
      return `${underThousand(n)} ${unit}`;
    }

    const parts: string[] = [];

    const billion = Math.floor(num / 1_000_000_000);
    const million = Math.floor((num % 1_000_000_000) / 1_000_000);
    const thousand = Math.floor((num % 1_000_000) / 1000);
    const remainder = Math.floor(num % 1000);

    if (billion) parts.push(sectionToWords(billion, 'مليار', 'ملياران', 'مليارات'));
    if (million) parts.push(sectionToWords(million, 'مليون', 'مليونان', 'ملايين'));
    if (thousand) parts.push(sectionToWords(thousand, 'ألف', 'ألفان', 'آلاف'));
    if (remainder) parts.push(underThousand(remainder));

    const integerWords = parts.join(' و ') || 'صفر';

    // Handle decimal part (up to 2 digits)
    const decimalPart = Math.round((num % 1) * 100);
    if (Number(this.rebateRequestLoaded.Currency) == 1) {
      if (decimalPart > 0) {
        return `${integerWords} دولار و ${underThousand(decimalPart)} سنت `;
      }
      else {
        return `${integerWords} دولار `;
      }
    }
    else if (Number(this.rebateRequestLoaded.Currency) == 3) {
      if (decimalPart > 0) {
        return `${integerWords} يورو و ${underThousand(decimalPart)} سنت `;
      }
      else {
        return `${integerWords} يورو `;
      }
    }
    else if (Number(this.rebateRequestLoaded.Currency) == 2) {
      if (decimalPart > 0) {
        return `${integerWords} جنيه مصرى و ${underThousand(decimalPart)} قرش `;
      }
      else {
        return `${integerWords} جنيه مصرى `;
      }
    }
    else {
      if (decimalPart > 0) {
        return `${integerWords} دولار و ${underThousand(decimalPart)} سنت `;
      }
      else {
        return `${integerWords} دولار `;
      }
    }

  }

  PrintRefundCover(e): void {
    e.preventDefault();
    this.PrintRefundPDF();
  }
  PrintRefundPDF() {
    let Background = SCAWaterMark.Background;
    let header1 = "جمهورية مصر العربية";
    let header2 = "هيئة قناة السويس";
    let header3 = "سفن الخطوط الطويلة";
    let header50;



    header1 = header1.split(" ").reverse().join("\u0020");
    header1 = header1.split(" ").reverse().join("\u00A0");
    header2 = header2.split(" ").reverse().join("\u0020");
    header2 = header2.split(" ").reverse().join("\u00A0");
    header3 = header3.split(" ").reverse().join("\u0020");
    header3 = header3.split(" ").reverse().join("\u00A0");
    let header4 = "مذكرة";
    let header5 = " للعرض علي السيد الفريق/ رئيس هيئة قناة السويس";
    header5 = header5.split(" ").reverse().join("\u0020");
    header5 = header5.split(" ").reverse().join("\u00A0");
    let header6 = "اسم السفينة:";
    header6 = header6.split(" ").reverse().join("\u0020");
    header6 = header6.split(" ").reverse().join("\u00A0");
    let header7 = "رقم الملف:";
    header7 = header7.split(" ").reverse().join("\u0020");
    header7 = header7.split(" ").reverse().join("\u00A0");
    let header8 = "تاريخ العبور:";
    header8 = header8.split(" ").reverse().join("\u0020");
    header8 = header8.split(" ").reverse().join("\u00A0");
    let header9 = "طلب تخفيض وارد من:";
    header9 = header9.split(" ").reverse().join("\u0020");
    header9 = header9.split(" ").reverse().join("\u00A0");
    let header10 = "لحساب:";
    header10 = header10.split(" ").reverse().join("\u0020");
    header10 = header10.split(" ").reverse().join("\u00A0");
    let header11 = "برقم:";
    header11 = header11.split(" ").reverse().join("\u0020");
    header11 = header11.split(" ").reverse().join("\u00A0");
    let header12 = "بتاريخ:";
    header12 = header12.split(" ").reverse().join("\u0020");
    header12 = header12.split(" ").reverse().join("\u00A0");

    let header13 = "تاريخ أول رد علي الطلبات:";
    header13 = header13.split(" ").reverse().join("\u0020");
    header13 = header13.split(" ").reverse().join("\u00A0");

    let header14 = "تاريخ الإبحار الفعلي:";
    header14 = header14.split(" ").reverse().join("\u0020");
    header14 = header14.split(" ").reverse().join("\u00A0");


    let header42 = " تاريخ أول رد على الطلب:";
    header42 = header42.split(" ").reverse().join("\u0020");
    header42 = header42.split(" ").reverse().join("\u00A0");

    let header15 = "تاريح بدء وصول المستندات:";
    header15 = header15.split(" ").reverse().join("\u0020");
    header15 = header15.split(" ").reverse().join("\u00A0");

    let header16 = "تاريخ استكمال ورود المستندات:";
    header16 = header16.split(" ").reverse().join("\u0020");
    header16 = header16.split(" ").reverse().join("\u00A0");
    let header17 = "الرحلة من:";
    header17 = header17.split(" ").reverse().join("\u0020");
    header17 = header17.split(" ").reverse().join("\u00A0");
    let header18 = "إلى:";
    header18 = header18.split(" ").reverse().join("\u0020");
    header18 = header18.split(" ").reverse().join("\u00A0");

    let header19 = "قامت لجنة الخطوط الطويلة بدراسة تكاليف رحلة السفينة عبر قناة السويس و عبر طريق رأس الرجاء الصالح أو الطريق البديل واتضح أن تكاليف رحلة السفينة عبر قناة السويس أكثر منها عبر طريق رأس الرجاء الصالح أو الطريق البديل";
    header19 = header19.split(" ").reverse().join("\u0020");
    header19 = header19.split(" ").reverse().join("\u00A0");


    let header21 = 'كما قامت مراقبة القياس بإدارة التحركات بمراجعة مستندات الرحلة المطلوبة و مدي صحتها ومطابقتها' + '\n' + 'لرحلة السفينة و التخفيض الممنوح ووجدت مستوفاة.';
    header21 = header21.split(" ").reverse().join("\u0020");
    header21 = header21.split(" ").reverse().join("\u00A0");

    let header22 = "قيمة التخفيض:";
    header22 = header22.split(" ").reverse().join("\u0020");
    header22 = header22.split(" ").reverse().join("\u00A0");
    let header23 = " دولار.";
    header23 = header23.split(" ").reverse().join("\u0020");
    header23 = header23.split(" ").reverse().join("\u00A0");

    let header44 = " يورو.";
    header44 = header44.split(" ").reverse().join("\u0020");
    header44 = header44.split(" ").reverse().join("\u00A0");

    let header45 = " جنيه مصرى.";
    header45 = header45.split(" ").reverse().join("\u0020");
    header45 = header45.split(" ").reverse().join("\u00A0");

    let header24 = "فقط و قدرة :    ";
    header24 = header24.split(" ").reverse().join("\u0020");
    header24 = header24.split(" ").reverse().join("\u00A0");

    let header43 = this.numberToArabicWordswithoutCurrency(Number(this.rebateRequestLoaded.ActualRebatePercentage));
    header43 = header43.split(" ").reverse().join("\u0020");
    header43 = header43.split(" ").reverse().join("\u00A0");
    let header46;
    if (this.rebateRequestLoaded.IsCircular) {
      header46 = this.convertToArabicNumbers(this.rebateRequestLoaded.CircularName);
      header46 = header46.split(" ").reverse().join("\u0020");
      header46 = header46.split(" ").reverse().join("\u00A0");
    }


    let header25 = this.numberToArabicWords(Number(this.rebateRequestLoaded.ActualRebateAmount));
    header25 = header25.split(" ").reverse().join("\u0020");
    header25 = header25.split(" ").reverse().join("\u00A0");
    /*let header20 = "ولكي يتم اجتذابها لعبور قناة السويس يستلزم ذلك تخفيض رسوم العبور العادية لهذه الرحلة بنسبة" + ' ' +  header43 + '% ' + " و بشرط عدم التوقف في اي موانئ بينية بغرض الشحن أو التفريغ )أغراض تجارية(";
    header20 = header20.split(" ").reverse().join("\u0020");
    header20 = header20.split(" ").reverse().join("\u00A0");*/



    /*let header20 = "ولكي يتم اجتذابها لعبور قناة السويس يستلزم ذلك تخفيض رسوم العبور العادية لهذه الرحلة بنسبة" + ' ' + this.convertToArabicNumbers(this.rebateRequestLoaded.ActualRebatePercentage).split('').reverse().join('') + '% ' + ')'+header43+'(' +" و بشرط عدم التوقف في اي موانئ بينية بغرض الشحن أو التفريغ )أغراض تجارية(";
    header20 = header20.split(" ").reverse().join("\u0020");
    header20 = header20.split(" ").reverse().join("\u00A0");*/

    let header26 = "لا غير .";
    header26 = header26.split(" ").reverse().join("\u0020");
    header26 = header26.split(" ").reverse().join("\u00A0");

    let header27 = "قسيمة رقم:   ";
    header27 = header27.split(" ").reverse().join("\u0020");
    header27 = header27.split(" ").reverse().join("\u00A0");

    let header28 = "توكيل:";
    header28 = header28.split(" ").reverse().join("\u0020");
    header28 = header28.split(" ").reverse().join("\u00A0");

    let header29 = "وبناء عليه يتم التنبيه برد قيمة التخفيض الي التوكيل المذكور أعلاه وذلك ليقوم برده إلى: ";
    header29 = header29.split(" ").reverse().join("\u0020");
    header29 = header29.split(" ").reverse().join("\u00A0");

    let header30 = "علما بأنه لم يسبق رد التخفيض.";
    header30 = header30.split(" ").reverse().join("\u0020");
    header30 = header30.split(" ").reverse().join("\u00A0");

    let header31 = "برجاء التكرم بالموافقة و والاعتماد.";
    header31 = header31.split(" ").reverse().join("\u0020");
    header31 = header31.split(" ").reverse().join("\u00A0");

    let header32 = "مراقبة القياس";
    header32 = header32.split(" ").reverse().join("\u0020");
    header32 = header32.split(" ").reverse().join("\u00A0");

    let header33 = "أعضاء لجنة";
    header33 = header33.split(" ").reverse().join("\u0020");
    header33 = header33.split(" ").reverse().join("\u00A0");




    let header34 = "ق. مدير إدارة التحركات";
    header34 = header34.split(" ").reverse().join("\u0020");
    header34 = header34.split(" ").reverse().join("\u00A0");

    let header35 = "مهندس";
    header35 = header35.split(" ").reverse().join("\u0020");
    header35 = header35.split(" ").reverse().join("\u00A0");


    let header36 = "مدير إدارة التخطيط و البحوث";
    header36 = header36.split(" ").reverse().join("\u0020");
    header36 = header36.split(" ").reverse().join("\u00A0");

    let header37 = "ورئيس لجـــنة الخطوط الطويلة";
    header37 = header37.split(" ").reverse().join("\u0020");
    header37 = header37.split(" ").reverse().join("\u00A0");

    let header38 = "د. أخصائي";
    header38 = header38.split(" ").reverse().join("\u0020");
    header38 = header38.split(" ").reverse().join("\u00A0");

    let header39 = "رئيس هيئة قناة السويس";
    header39 = header39.split(" ").reverse().join("\u0020");
    header39 = header39.split(" ").reverse().join("\u00A0");

    let header40 = "فريق";
    header40 = header40.split(" ").reverse().join("\u0020");
    header40 = header40.split(" ").reverse().join("\u00A0");

    let header41 = "الخطوط الطويلة";
    header41 = header41.split(" ").reverse().join("\u0020");
    header41 = header41.split(" ").reverse().join("\u00A0");


    let header20 = '';
    if (this.rebateRequestLoaded.IsCircular) {
      header20 = "ولكي يتم اجتذابها لعبور قناة السويس يستلزم ذلك تخفيض رسوم العبور العادية لهذه الرحلة بنسبة" + ' ' + this.convertToArabicNumbers(this.rebateRequestLoaded.ActualRebatePercentage).split('').reverse().join('') + '% ' + ') منشور ' + header46.split('').reverse().join('') + ' ( ' + '\n' + " و بشرط عدم التوقف في اي موانئ بينية بغرض الشحن أو التفريغ )أغراض تجارية(";
      header20 = header20.split(" ").reverse().join("\u0020");
      header20 = header20.split(" ").reverse().join("\u00A0");
    }
    else {
      header20 = "ولكي يتم اجتذابها لعبور قناة السويس يستلزم ذلك تخفيض رسوم العبور العادية لهذه الرحلة بنسبة" + ' ' + this.convertToArabicNumbers(this.rebateRequestLoaded.ActualRebatePercentage).split('').reverse().join('') + '% ' + ')' + header43 + ' (' + '\n' + " و بشرط عدم التوقف في اي موانئ بينية بغرض الشحن أو التفريغ )أغراض تجارية(";
      header20 = header20.split(" ").reverse().join("\u0020");
      header20 = header20.split(" ").reverse().join("\u00A0");
    }
//alaa




    let wfSignedAdmins = "";
    const addedNames = new Set<string>();
    this.arabicNames.forEach(name=>{
      this.refundwfSignedAdmins.slice(1).forEach(element => {
        if(name.Email == element.UserEmail){
          const formattedName = name.NameAR.split(" ").reverse().join("\u0020").split(" ").reverse().join("\u00A0")
          if (!addedNames.has(formattedName)) {
            addedNames.add(formattedName);
            wfSignedAdmins += formattedName + "\n\n";
          }
      }});
    })

    if (Number(this.rebateRequestLoaded.Currency) == 1) {
      header50 = header23 + '      ' + this.convertToArabicNumbers(this.rebateRequestLoaded.ActualRebateAmount).split('').reverse().join('')
    }
    else if (Number(this.rebateRequestLoaded.Currency) == 2) {
      header50 = header45 + '      ' + this.convertToArabicNumbers(this.rebateRequestLoaded.ActualRebateAmount).split('').reverse().join('')
    }
    else if (Number(this.rebateRequestLoaded.Currency) == 3) {
      header50 = header44 + '      ' + this.convertToArabicNumbers(this.rebateRequestLoaded.ActualRebateAmount).split('').reverse().join('')
    }
    let docDefinition = {
      background: function (currentPage, pageCount, pageSize) {
        return [
          {
            image: Background,
            //height: 845,
            //width:600,
            opacity: 0.9,
            fit: [600, 845]
          },
        ]
      },
      content: [
        {
          text: header1,
          style: 'arabic'
        },
        {
          text: header2,
          style: 'arabic'
        },
        {
          text: header3,
          style: 'arabic'
        },
        {
          text: header4,
          style: 'center',
          decoration: 'underline',
        },
        {
          text: header5 + "",
          style: 'center',
          decoration: 'underline',
        },
        {
          text: "\n",
          style: 'center',
        },
        {
          text: this.rebateRequestLoaded.VesselName.toLocaleUpperCase() + ' ' + header6,
          style: 'col',

        },
        {
          text: "\n",
          style: 'center',
        },
        {
          columns: [
            { text: this.convertToArabicNumbers(this.datePipe.transform(this.rebateRequestLoaded.TransitDate, 'yyyy/MM/dd')).split('').reverse().join('') + ' ' + header8, style: 'col', },
            { text: this.rebateRequestLoaded.RebateFileNumber + ' ' + header7, style: 'col', },
           // { text: this.rebateRequestLoaded.VesselName + ' ' + header6, style: 'col', },
          ],
          margin: [0, 0, 0, 5]
        },
        {
          columns: [
            //{ text: this.rebateRequestLoaded.PrincipalName + ' ' + header10, style: 'col', },
            { text: this.rebateRequestLoaded.RequestorName.toLocaleUpperCase() + ' ' + header9, style: 'col', },
          ],
          margin: [0, 0, 0, 5]
        },

        {
          columns: [
            { text: this.rebateRequestLoaded.PrincipalName.toLocaleUpperCase() + ' ' + header10, style: 'col', },
           // { text: this.rebateRequestLoaded.RequestorName + ' ' + header9, style: 'col', },
          ],
          margin: [0, 0, 0, 5]
        },

        {
          columns: [
            { text: this.convertToArabicNumbers(this.datePipe.transform(this.rebateRequestLoaded.BaseRequestCreationDate, 'yyyy/MM/dd')).split('').reverse().join('') + ' ' + header12, style: 'col', },
            { text: this.rebateRequestLoaded.BaseRequestRequestNumber + ' ' + header11, style: 'col', },
          ],
          margin: [0, 0, 0, 5]
        },

        {
          columns: [
            { text: this.convertToArabicNumbers(this.datePipe.transform(this.rebateRequestLoaded.DocumnetedSailingDate, 'yyyy/MM/dd')).split('').reverse().join('') + ' ' + header14, style: 'col', },
            { text: this.convertToArabicNumbers(this.datePipe.transform(this.rebateRequestLoaded.FormulateDecisionDate, 'yyyy/MM/dd')).split('').reverse().join('') + ' ' + header42, style: 'col', },
            //{ text: this.datePipe.transform(this.rebateRequestLoaded.DateOfLastReceivedDocuments, 'dd/MM/yyyy') + ' ' + header13, style: 'col', },
          ],
          margin: [0, 0, 0, 5]
        },

        {
          columns: [
            { text: this.convertToArabicNumbers(this.datePipe.transform(this.rebateRequestLoaded.DatesOfReceivingLastAgentCorrespondence, 'yyyy/MM/dd')).split('').reverse().join('') + ' ' + header16, style: 'col', },
            //{ text: this.convertToArabicNumbers(this.datePipe.transform(this.rebateRequestLoaded.DateofLastAgentCorrespondence, 'yyyy/MM/dd')).split('').reverse().join('') + ' ' + header15, style: 'col', },
          ],
          margin: [0, 0, 0, 5]
        },
        {
          columns: [
            { text: this.rebateRequestLoaded.VoyageCertificatesDestinationPort.toLocaleUpperCase() + ' ' + header18, style: 'col', },
            { text: this.rebateRequestLoaded.VoyageCertificatesOriginPort.toLocaleUpperCase() + ' ' + header17, style: 'col', },
          ],
          margin: [0, 0, 0, 5]
        },

        {
          text: header19,
          style: 'arabic',
        },

        {
          text: header20,
          style: 'arabic',
        },

        {
          text: header21,
          style: 'arabic',
        },
        {
          text: "\n",
          style: 'center',
        },

        {
          columns: [
            { text: '                     ', style: 'col', },

            { text: header50, style: 'col', },
            { text: header22, style: 'col', },
          ],
          margin: [0, 0, 0, 5]
        },
        {
          columns: [
            // { text: '           ', style: 'col', },
            //{ text: header26, style: 'col', },
            { text: header24 + header25 + header26, style: 'col', },
            //{ text: header24, style: 'col', },


          ],
          // margin: [0, 0, 0, 5]
        },
        {
          text: "\n",
          style: 'center',
        },
        {
          columns: [
            { text: this.rebateRequestLoaded.transitAgentName.toLocaleUpperCase() + ' ' + header28, style: 'col', },
           // { text: header27 + '' + this.convertToArabicNumbers(this.rebateRequestLoaded.InvoiceNo).split('').reverse().join(''), style: 'col', },
            { text: header27 + '' + this.rebateRequestLoaded.InvoiceNo.split('').reverse().join(''), style: 'col', },
          ],
          margin: [0, 0, 0, 7]
        },

        {
          columns: [
           // { text: this.rebateRequestLoaded.PrincipalName, style: 'col', },

            { text: header29 + ' ' , style: 'col', },
          ],
          margin: [0, 0, 0, 5]
        },
        {
          columns: [
            { text: this.rebateRequestLoaded.PrincipalName.toLocaleUpperCase(), style: 'col', },

           // { text: header29 + ' ' , style: 'col', },
          ],
          margin: [0, 0, 0, 5]
        },
       /* {
          text:  this.rebateRequestLoaded.PrincipalName +'     '+ header29 ,
          style: 'arabic',
        },*/
        {
          text: '\n',
          style: 'arabic',
        },
        {
          text: header30,
          style: 'arabic',
        },
        {
          text: header31,
          style: 'arabic',
        },
        {
          text: "\n ",
          style: 'center',
        },
        {
          columns: [
            { text: header36 + "\n" + header37 + "\n " + header38 + "\n \n \n \n " + this.translate.instant('SHARED.PlanningDirector').split(" ").reverse().join("\u0020").split(" ").reverse().join("\u00A0") + "\n \n \n \n" + header39 + "\n" + header40 + "\n \n \n \n"  +this.translate.instant('SHARED.CEO').split(" ").reverse().join("\u0020").split(" ").reverse().join("\u00A0") , style: 'Scol', },
            { text: header34 + "\n " + header35 + "\n \n \n \n \n" + this.translate.instant('SHARED.transitDirector').split(" ").reverse().join("\u0020").split(" ").reverse().join("\u00A0"), style: 'Scol', },
            { text: header33 + "\n" + header41 + "\n \n" + wfSignedAdmins, style: 'col', },
            { text: header32 + "\n \n \n" + this.getNameByEmail(this.refundwfSignedAdmins[0].UserEmail.toLocaleLowerCase()).split(" ").reverse().join("\u0020").split(" ").reverse().join("\u00A0"), style: 'Scol', },

          ]
        },





      ],

      styles: {
        arabic: {
          font: "Arial",
          alignment: "right",
          direction: "rtl",
          rtl: true,
        },
        header: {
          font: "Arial",
          fontSize: 18,
          alignment: "right",
          direction: "rtl",
          rtl: true,
          bold: true,
          margin: [0, 0, 0, 10]
        },
        center: {
          font: "Arial",
          alignment: "center",
          direction: "rtl",
          rtl: true,
        },
        col: {
          font: "Arial",
          alignment: "right",
          direction: "rtl",
          fontSize: 12,
          rtl: true,
        },
        Scol: {
          font: "Arial",
          alignment: "center",
          direction: "rtl",
          fontSize: 12,
          rtl: true,
        },
        subheader: {
          font: "Arial",
          alignment: "right",
          direction: "rtl",
          rtl: true,
          bold: true,
          fontSize: 16,

          margin: [0, 10, 0, 5]
        },
        tableExample: {
          font: "Arial",
          alignment: "center",
          direction: "rtl",
          rtl: true,
          bold: true,
          margin: [0, 5, 0, 15]
        },
        tableHeader: {
          font: "Arial",
          alignment: "right",
          direction: "rtl",
          rtl: true,
          bold: true,
          fontSize: 13,
          color: 'black'
        }
      },

    }
    pdfMake.fonts = {
      Arial: {
        normal: 'Arial-Regular.ttf',
        bold: 'Arial-Regular.ttf',
        italics: 'Arial-Regular.ttf',
        bolditalics: 'Arial-Regular.ttf'
      }
    },
      pdfMake.createPdf(docDefinition).open();

  }
  convertToArabicNumbers(input: string): string {
    if(input!= undefined || input!= null){
    const arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    return input.replace(/\d/g, (digit) => arabicDigits[parseInt(digit)]);}
    else{
    return null;
    }
  }
  PrintRestudyCover(e): void {
    e.preventDefault();
    this.PrintRestudyPDF();
  }
  PrintRestudyPDF() {
    let eunitItems = "";
    const eunitNames = new Set<string>();
    debugger;
    this.arabicNames.forEach(name=>{
      this.restudyeunitItems.slice(1).forEach(element => {
        if(name.Email == element.UserEmail){
          const formattedName = name.NameAR.split(" ").reverse().join("\u0020").split(" ").reverse().join("\u00A0")
          if (!eunitNames.has(formattedName)) {
            eunitNames.add(formattedName);
            eunitItems += formattedName + "\n\n";
          }
      }});
    })
    var options = [];
    let Background = SCAWaterMark.Background;
    let logo = Logo.logo;
    let Dept = "إدارة التحركات";
    let Section = "مراقبة القياس";
    Dept = Dept.split(" ").reverse().join("\u0020");
    Dept = Dept.split(" ").reverse().join("\u00A0");
    Section = Section.split(" ").reverse().join("\u0020");
    Section = Section.split(" ").reverse().join("\u00A0");
    let header4 = "مذكرة عرض ";
    header4 = header4.split(" ").reverse().join("\u0020");
    header4 = header4.split(" ").reverse().join("\u00A0");
    let header5 = "لجنة خطوط طويلة";
    header5 = header5.split(" ").reverse().join("\u0020");
    header5 = header5.split(" ").reverse().join("\u00A0");
    let header6 = "اسم السفينة:";
    header6 = header6.split(" ").reverse().join("\u0020");
    header6 = header6.split(" ").reverse().join("\u00A0");
    let header7 = "ملف رقم:";
    header7 = header7.split(" ").reverse().join("\u0020");
    header7 = header7.split(" ").reverse().join("\u00A0");

    let header8 = "طلب تخفيض رقم:";
    header8 = header8.split(" ").reverse().join("\u0020");
    header8 = header8.split(" ").reverse().join("\u00A0");

    let header9 = "الوارد من توكيل:";
    header9 = header9.split(" ").reverse().join("\u0020");
    header9 = header9.split(" ").reverse().join("\u00A0");

    let header10 = "بتاريخ:";
    header10 = header10.split(" ").reverse().join("\u0020");
    header10 = header10.split(" ").reverse().join("\u00A0");

    let header11 = "ميناء قيام:";
    header11 = header11.split(" ").reverse().join("\u0020");
    header11 = header11.split(" ").reverse().join("\u00A0");

    let header12 = " ميناء وصول:";
    header12 = header12.split(" ").reverse().join("\u0020");
    header12 = header12.split(" ").reverse().join("\u00A0");

    let header13 = "بتاريخ رد:";
    header13 = header13.split(" ").reverse().join("\u0020");
    header13 = header13.split(" ").reverse().join("\u00A0");

    let header14 = " بنسبة تخفيض:";
    header14 = header14.split(" ").reverse().join("\u0020");
    header14 = header14.split(" ").reverse().join("\u00A0");

    let header15 = "تاريخ عبور:";
    header15 = header15.split(" ").reverse().join("\u0020");
    header15 = header15.split(" ").reverse().join("\u00A0");

    let header16 = "و قد وردت المستندات النهائية يوم:";
    header16 = header16.split(" ").reverse().join("\u0020");
    header16 = header16.split(" ").reverse().join("\u00A0");

    let header17 = "و بمراجعتها تبين أن البيانات الفعلية كالتالى:";
    header17 = header17.split(" ").reverse().join("\u0020");
    header17 = header17.split(" ").reverse().join("\u00A0");


    let header18 = "تاريخ الإبحار";
    header18 = header18.split(" ").reverse().join("\u0020");
    header18 = header18.split(" ").reverse().join("\u00A0");

    let header40 = "تاريخ أول رد على الطلب";
    header40 = header40.split(" ").reverse().join("\u0020");
    header40 = header40.split(" ").reverse().join("\u00A0");

    let header19 = "الحمولة الصافية";
    header19 = header19.split(" ").reverse().join("\u0020");
    header19 = header19.split(" ").reverse().join("\u00A0");

    let header20 = "ميناء القيام ";
    header20 = header20.split(" ").reverse().join("\u0020");
    header20 = header20.split(" ").reverse().join("\u00A0");

    let header21 = "ميناء الوصول";
    header21 = header21.split(" ").reverse().join("\u0020");
    header21 = header21.split(" ").reverse().join("\u00A0");

    let header22 = "ملاحظات";
    header22 = header22.split(" ").reverse().join("\u0020");
    header22 = header22.split(" ").reverse().join("\u00A0");


    let header23 = "سبب إعادة الدراسة";
    header23 = header23.split(" ").reverse().join("\u0020");
    header23 = header23.split(" ").reverse().join("\u00A0");

    let header24 = "برجاء موافتنا بما يتبع بشأن التخفيض";
    header24 = header24.split(" ").reverse().join("\u0020");
    header24 = header24.split(" ").reverse().join("\u00A0");


    let header25 = "و شكرا ,,,,,";
    header25 = header25.split(" ").reverse().join("\u0020");
    header25 = header25.split(" ").reverse().join("\u00A0");



    let header26 = "نائب مدير إدارة التحركات";
    header26 = header26.split(" ").reverse().join("\u0020");
    header26 = header26.split(" ").reverse().join("\u00A0");



    let header27 = "رئيس مراقبة القياس";
    header27 = header27.split(" ").reverse().join("\u0020");
    header27 = header27.split(" ").reverse().join("\u00A0");


    let header28 = "فئة الرسوم";
    header28 = header28.split(" ").reverse().join("\u0020");
    header28 = header28.split(" ").reverse().join("\u00A0");

    let header33 = 'أعضاء اللجـــنة';
    header33 = header33.split(" ").reverse().join("\u0020");
    header33 = header33.split(" ").reverse().join("\u00A0");




    let header34 = "ق. مدير إدارة التحركات";
    header34 = header34.split(" ").reverse().join("\u0020");
    header34 = header34.split(" ").reverse().join("\u00A0");

    let header35 = "مهندس";
    header35 = header35.split(" ").reverse().join("\u0020");
    header35 = header35.split(" ").reverse().join("\u00A0");


    let header36 = "مدير إدارة التخطيط و البحوث";
    header36 = header36.split(" ").reverse().join("\u0020");
    header36 = header36.split(" ").reverse().join("\u00A0");

    let header37 = "ورئيس لجـــنة الخطوط الطويلة";
    header37 = header37.split(" ").reverse().join("\u0020");
    header37 = header37.split(" ").reverse().join("\u00A0");

    let header38 = "د. أخصائي";
    header38 = header38.split(" ").reverse().join("\u0020");
    header38 = header38.split(" ").reverse().join("\u00A0");

    let header39 = "رئيس هيئة قناة السويس";
    header39 = header39.split(" ").reverse().join("\u0020");
    header39 = header39.split(" ").reverse().join("\u00A0");

    let header41 = "توقيع";
    header41 = header41.split(" ").reverse().join("\u0020");
    header41 = header41.split(" ").reverse().join("\u00A0");

    let wfSignedAdmins = "";
    const addedNames = new Set<string>();
    this.arabicNames.forEach(name=>{
      this.restudyfSignedAdmins.slice(1).forEach(element => {
        if(name.Email == element.UserEmail){
          const formattedName = name.NameAR.split(" ").reverse().join("\u0020").split(" ").reverse().join("\u00A0")
          if (!addedNames.has(formattedName)) {
            addedNames.add(formattedName);
            wfSignedAdmins += formattedName + "\n\n";
          }
        }})})



  this.longHaulRequestOptions.forEach(element => {
    let percentage = this.LongHaulRequestOptionsFormulatedDecision.find(i => i.Id === element.Id).RebatePercentage;
    let portoforigin = "";
    let portofdestination = "";

    if (element.LastPortOriginId != null && element.LastPortOriginId != -1) {
      portoforigin = this.ports.filter(c => c.Id == Number(element.LastPortOriginId))[0].NameEN;
    }
    else {
      portoforigin = element.OtherLastPortOrigin;
    }


    if (element.FirstPortDestinationId != null && element.FirstPortDestinationId != -1) {
      portofdestination = this.ports.filter(c => c.Id == Number(element.FirstPortDestinationId))[0].NameEN;
    }
    else {
      portofdestination = element.OtherFirstPortDestination;
    }

    let option = [{
      columns: [
        { text: this.convertToArabicNumbers(percentage).split('').reverse().join('') + '% '+ ' ' + header14, style: 'col', },
        { text: portofdestination.toLocaleUpperCase() + ' ' + header12, style: 'col', },
        { text: portoforigin.toLocaleUpperCase() + ' ' + header11, style: 'col', },
      ],
      margin: [0, 0, 0, 10]
    }];
    options.push(option);

  });

    let Initiator_name = this.getNameByEmail(this.restudymeasureItems[0].UserEmail.toLocaleLowerCase()).split(" ").reverse().join("\u0020").split(" ").reverse().join("\u00A0");
    let Reviewer_name =  this.getNameByEmail(this.restudymeasureItems[1].UserEmail.toLocaleLowerCase()).split(" ").reverse().join("\u0020").split(" ").reverse().join("\u00A0");
    let Manager_name =  this.getNameByEmail(this.restudymeasureItems[2].UserEmail.toLocaleLowerCase()).split(" ").reverse().join("\u0020").split(" ").reverse().join("\u00A0");
    let EunitRegisterNotes=""
    if(this.restudyRequestObj.EunitRegistersDecision== RestudyEconomicManagerDecision.Modify){
       EunitRegisterNotes = this.restudyRequestObj.EunitModifyRebateNote;
    }
    else
    {
       EunitRegisterNotes = this.restudyRequestObj.EunitRegisterNotes;
    }

    let ReleaseFormDecisionNote = this.rebateRequestLoaded.ReleaseFormDecisionNote;
    let reason = this.rebateRequestLoaded.SelectedReason;
    let x = hasArabic(EunitRegisterNotes);
    let y = hasArabic(ReleaseFormDecisionNote);
    let z = hasArabic(reason);
    let TheTable;
    let noteTable;
    let reasonTable;



    if(EunitRegisterNotes!=null){
      EunitRegisterNotes = ArabicAndEnglishTogether(EunitRegisterNotes);
      if (x){
        TheTable = {style: 'table2',
         table: {
           margin: [15, 5, 5, 5],
           widths: [505],
           height:['*'],
           body: [[
              {text:EunitRegisterNotes,margin: [15, 0, 0, 0]},
           ]
         ]
        },
        layout: {
         paddingLeft: function(i, node) { return 5; },
         paddingRight: function(i, node) { return 5; },
         paddingTop: function(i, node) { return 5; },
         paddingBottom: function(i, node) { return 5; },
        },
         margin: [0, 5, 5, 5]
       }
     }
     else
     {
        TheTable = {style: 'table3',
         table: {
           margin: [15, 5, 5, 5],
           widths: [505],
           height:['*'],
           body: [[
              {text:EunitRegisterNotes,margin: [5, 0, 0, 0]},
           ]
         ]
        },
        layout: {
         paddingLeft: function(i, node) { return 5; },
         paddingRight: function(i, node) { return 5; },
         paddingTop: function(i, node) { return 5; },
         paddingBottom: function(i, node) { return 5; },
        },
         margin: [0, 5, 5, 5]
       }
     }

    }

    if(ReleaseFormDecisionNote!=null){
      ReleaseFormDecisionNote = ArabicAndEnglishTogether(ReleaseFormDecisionNote);

      if (y){
        noteTable= {
          style: 'tableExample1',
          table: {
            widths: ['*'],
            body: [
            [{text: header22, style: 'tableHeaderReason', colSpan: 1, alignment: 'right'}],
              [ReleaseFormDecisionNote]
            ]
          },
          margin: [0, 5, 5, 5]
        }
     }
     else
     {
      noteTable= {
        style: 'tableExample2',
        table: {
          widths: ['*'],
          body: [
          [{text: header22, style: 'tableHeaderReason', colSpan: 1, alignment: 'right'}],
            [ReleaseFormDecisionNote]
          ]
        }
      }
     }
    }

    if(reason!=null){
      reason = ArabicAndEnglishTogether(reason);

      if (z){
        reasonTable= {
            style: 'tableExample1',
            table: {
              headerRows: 1,
              widths: ['*'],
              body: [//here
                //[header23],
                [{text: header23, style: 'tableHeaderReason', colSpan: 1, alignment: 'right'}],

                [this.rebateRequestLoaded.SelectedReason ]
              ]
            },
            margin: [0, 0, 0,10]
          }
     }
     else
     {
      reasonTable= {
        style: 'tableExample2',
        table: {
          headerRows: 1,
          widths: ['*'],
          body: [//here
            //[header23],
            [{text: header23, style: 'tableHeaderReason', colSpan: 1, alignment: 'right'}],

            [this.rebateRequestLoaded.SelectedReason ]
          ]
        },
        margin: [0, 0, 0,10]
      }
     }
    }



    let docDefinition = {
      background: function (currentPage, pageCount, pageSize) {
        return [
          {
            image: Background,
            //height: 845,
            //width:600,
            opacity: 0.9,
            fit: [600, 845]
          },
        ]
      },
      content: [
        {
          columns: [
            {
              image: logo,
              width: 60,
              height: 60,
              alignment: 'left'
            },
            {
              stack: [
                { text: Dept, style: 'arabic' },
                { text: Section, style: 'arabic' }
              ],
              alignment: 'right',
              margin: [0, 25, 0, 0]
            }
          ]
        },
        {
          text: header4,
          style: 'center',
          decoration: 'underline',
        },
        {
          text: header5,
          style: 'center',
          decoration: 'underline',
        },
        {
          text: "\n",
          style: 'center',
        },
        {
          text: this.rebateRequestLoaded.VesselName.toLocaleUpperCase() + ' ' + header6,
          style: 'col',
          margin: [0, 0, 0, 6]
        },

        {
          columns: [
            { text: this.convertToArabicNumbers(this.datePipe.transform(this.rebateRequestLoaded.TransitDate, 'yyyy/MM/dd')).split('').reverse().join('') + ' ' + header15, style: 'col', },
            { text: this.rebateRequestLoaded.RebateFileNumber + ' ' + header7, style: 'col', },
           // { text: this.rebateRequestLoaded.VesselName + ' ' + header6, style: 'col', },
          ],
          margin: [0, 0, 0, 6]
        },

        {
          columns: [
            { text: this.convertToArabicNumbers(this.datePipe.transform(this.rebateRequestLoaded.BaseRequestCreationDate, 'yyyy/MM/dd')).split('').reverse().join('') + ' ' + header10, style: 'col', },
            { text: this.rebateRequestLoaded.BaseRequestRequestNumber + ' ' + header8, style: 'col', },

           // { text: this.rebateRequestLoaded.RequestorName + ' ' + header9, style: 'col', },
          ],
          margin: [0, 0, 0, 6]
        },
        {
          columns: [
            //{ text: this.rebateRequestLoaded.PrincipalName + ' ' + header10, style: 'col', },
            { text: this.rebateRequestLoaded.RequestorName.toLocaleUpperCase() + ' ' + header9, style: 'col', },
          ],
          margin: [0, 0, 0, 6]
        },
        options,


        {
          columns: [

            { text: this.convertToArabicNumbers(this.datePipe.transform(this.rebateRequestLoaded.FormulateDecisionDate, 'yyyy/MM/dd')).split('').reverse().join('') + ' ' + header13, style: 'col', },
            //{ text: this.datePipe.transform(this.rebateRequestLoaded.DateOfLastReceivedDocuments, 'dd/MM/yyyy') + ' ' + header13, style: 'col', },
          ],
          margin: [0, 0, 0, 6]
        },

        {
          columns: [
            { text: header17 + '    ' + this.convertToArabicNumbers(this.datePipe.transform(this.rebateRequestLoaded.DatesOfReceivingLastAgentCorrespondence, 'yyyy/MM/dd')).split('').reverse().join('') + '    ' + header16, style: 'col', },
            //{ text: this.convertToArabicNumbers(this.datePipe.transform(this.rebateRequestLoaded.DateofLastAgentCorrespondence, 'yyyy/MM/dd')).split('').reverse().join('') + ' ' + header15, style: 'col', },
            //{ text: header15, style: 'col', },
          ],
          margin: [0, 0, 0, 6]
        },
        {
          style: 'tableExample',
          table: {
            widths: ['*', '*', '*', '*','*'],
            body: [//here
              [header21, header20,header28,header19, header18],
              [this.releaseRequestForm.controls['TabFour'].get('VoyageCertificatesDestinationPort').value, this.releaseRequestForm.controls['TabFour'].get('VoyageCertificatesOriginPort').value ,this.rates.find(i => i.Id == this.releaseRequestForm.controls['TabThree'].get('TransitRateId').value).NameAR ,this.releaseRequestForm.controls['TabThree'].get('TransitSCNT').value,this.convertToArabicNumbers(this.datePipe.transform(this.rebateRequestLoaded.DocumnetedSailingDate, 'yyyy/MM/dd')).split('').reverse().join('')]
            ]
          },
          margin: [0, 0, 0, 10]
        },

        {
          style: 'tableExample2',
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [//here
              //[header23],
              [{text: header23, style: 'tableHeaderReason', colSpan: 1, alignment: 'right'}],

              [this.rebateRequestLoaded.SelectedReason ]
            ]
          },
          margin: [0, 0, 0,10]
        },

        noteTable,

        /*{
          text: header24,
          style: 'arabic',
          margin: [0, 0, 0, 10]
        },
        {
          text: header25,
          style: 'center',
          margin: [0, 0, 0, 10]
        },*/

        {
          //here
          columns: [
            { text: header26 + "\n " + header27 + "\n \n" + Manager_name, style: 'Scol', },
            { text: header25 + "\n \n \n"+ Reviewer_name, style: 'Scol', },
            { text: header24 + "\n \n \n"+ Initiator_name,  style: 'Scol', },

          ]
        },
        {
          text: "\n ",

        },

          TheTable,


        {
          text: "\n \n",
        },

        {
          columns: [
            { text: header36 + "\n" + header37 + "\n " + header38 + "\n \n \n \n" + this.translate.instant('SHARED.PlanningDirector').split(" ").reverse().join("\u0020").split(" ").reverse().join("\u00A0") + "\n \n \n " , style: 'Scol', },
            { text: header34 + "\n " + header35 + "\n \n \n \n \n" + this.translate.instant('SHARED.transitDirector').split(" ").reverse().join("\u0020").split(" ").reverse().join("\u00A0"), style: 'Scol', },
            { text: header33 + "\n \n \n \n" + eunitItems, style: 'Scol', },
            //{ text: "\n \n \n" + this.getNameByEmail(this.wfSignedAdmins[0].UserEmail.toLocaleLowerCase()).split(" ").reverse().join("\u0020").split(" ").reverse().join("\u00A0"), style: 'Scol', },

          ]
        }
      ],


      styles: {
        /*tableExample: {
          margin: [0, 5, 0, 15]
        },*/
        arabic: {
          font: "Arial",
          alignment: "right",
          direction: "rtl",
          rtl: true,
        },
        header: {
          font: "Arial",
          fontSize: 18,
          alignment: "right",
          direction: "rtl",
          rtl: true,
          bold: true,
          margin: [0, 0, 0, 10]
        },
        center: {
          font: "Arial",
          alignment: "center",
          direction: "rtl",
          rtl: true,
        },
        col: {
          font: "Arial",
          alignment: "right",
          direction: "rtl",
          rtl: true,
        },
        //alaa
      Scol: {
        font: "Arial",
        alignment: "center",
        direction: "rtl",
        fontSize: 12,
        rtl: true,
      },
        subheader: {
          font: "Arial",
          alignment: "right",
          direction: "rtl",
          rtl: true,
          bold: true,
          fontSize: 16,

          margin: [0, 5, 0, 5]
        },
        table2: {
          font: "Arial",
          alignment: "right",
          direction: "rtl",
          textDirection: 'rtl',
          fontSize: 10,
          rtl: true,
          bold: true,
          noWrap: false,
         // margin: [0, 5, 0, 5]
        },
        table3: {
          font: "Arial",
          alignment: "left",
          direction: "ltr",
          textDirection: "ltr",
          fontSize: 10,
          bold: true,
          noWrap: false
        },
        tableExample: {
          font: "Arial",
          alignment: "center",

          fontSize: 12,

          bold: true,
          noWrap: false,
          margin: [0, 5, 0, 5]
        },
        tableExample1: {
          font: "Arial",
          alignment: "right",
          direction: "rtl",
          textDirection: 'rtl',
          fontSize: 12,
          rtl: true,
          bold: true,
          noWrap: false,
          margin: [0, 5, 0, 5]
        },
        tableExample2: {
          font: "Arial",
          alignment: "left",
          direction: "ltr",
          textDirection: 'ltr',
          fontSize: 12,
          bold: true,
          noWrap: false,
          margin: [0, 5, 0, 5]
        },
        tableHeaderReason: {
          fontSize: 14,
          bold: true,

        },
        tableHeader: {
          font: "Arial",
          alignment: "right",
          direction: "rtl",
          rtl: true,
          bold: true,
          fontSize: 13,
          color: 'black'
        }
      },


    }
    pdfMake.fonts = {
      Arial: {
        normal: 'Arial-Regular.ttf',
        bold: 'Arial-Regular.ttf',
        italics: 'Arial-Regular.ttf',
        bolditalics: 'Arial-Regular.ttf'
      }
    },
      pdfMake.createPdf(docDefinition).open();

  }
    buildForm(): void {
    this.releaseRequestForm = this.formBuilder.group({
      TabOne: this.formBuilder.group({
        IMONo: ['', [Validators.required, Validators.pattern("^[0-9]{7,9}$")]],
        RebateFileNumber: ['', [Validators.required]],
        SupplierPhone: new FormControl('+93  234234243', [Validators.required]),
        BaseRequestRequestNumber: ['', [Validators.required]],
        BaseRequestCreationDate: ['', [Validators.required]],
        PrincipalName: ['', [Validators.required, Validators.pattern("[^=]+"), Validators.maxLength(200)]],
        PrincipalEmail: ['', [Validators.pattern('^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,9})$'), Validators.maxLength(50)]],
        PrincipalFax: [''],
        RequestorName: ['', [Validators.required, Validators.pattern("[^=]+"), Validators.maxLength(200)]],
        RequestorEmail: ['', [Validators.pattern('^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,9})$'), Validators.maxLength(50)]],
        RequestorFax: [''],
        VesselName: ['', [Validators.required, Validators.pattern("[^=]+"), Validators.maxLength(200)]],

      }),
      TabTwo: this.formBuilder.group({
        SCNT: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{0,5}([.][0-9]{1,2}|)$"), Validators.maxLength(50)]],
        DWT: ['', [Validators.required, Validators.pattern("^[0-9]{1,6}$"), Validators.maxLength(50)]],
        AcceptDataRateId: [null, [Validators.required]],
        FormulateDecisionDate: ['', [Validators.required]],
        ExtraCost: [''],
        Actualvoyage: ['', [Validators.required]],
        OriginPort: ['', [Validators.required]],
        DestinationPort: ['', [Validators.required]],
        RebatePercentage: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(200)]],

      }),
      TabThree: this.formBuilder.group({
        TransitDate: ['', [Validators.required]],
        TransitRateId: ['', [Validators.required]],
        VesselTypeId: ['', [Validators.required]],
        IsShipLoaded: ['', [Validators.required]],
        Transitagent: ['', [Validators.required]],

        TransitagentFax: [''],
        TransitagentEmail: ['', [Validators.required, Validators.pattern('^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,9})$'), Validators.maxLength(50)]],
        TransitSCNT: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{0,5}([.][0-9]{1,2}|)$"), Validators.maxLength(50)]],
        TransitDWT: ['', [Validators.required, Validators.pattern("^[0-9]{1,6}$"), Validators.maxLength(50)]],
        TransitRebatePercentage: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(200)]],
        ActualRebatePercentage: ['', [Validators.pattern("^[0-9]*$"), Validators.maxLength(200)]],
        RebateAmountAsPerInvoice: ['', [Validators.pattern("^[0-9]*([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],
        ActualRebateAmount: ['', [Validators.pattern("^[0-9]*([.][0-9]{1,2}|)$"), Validators.maxLength(200)]],
        DiffAmount: [''],
        Currency: ['', [Validators.required]],
        InvoiceNo: ['', [Validators.required]],
        transitAgentName: ['', [Validators.required]],
        IsCircular: ['', [Validators.required]],
        CircularName: [''],
        IsException: ['', [Validators.required]],
        ExceptionNote: ['', [Validators.required]],
      }),
      TabFour: this.formBuilder.group({
        DateofLastAgentCorrespondence: ['', [Validators.required]],
        DatesOfReceivingLastAgentCorrespondence: ['', [Validators.required]],
        //DateOfLastReceivedDocuments: ['', []],
        VoyageCertificatesOriginPort: ['', [Validators.required]],
        DocumnetedSailingDate: ['', [Validators.required]],
        VoyageCertificatesDestinationPort: ['', [Validators.required]],
        DocumnetedArrivalDate: ['', [Validators.required]],
        VoyageStoppageDetails: this.formBuilder.array([]),
        DocsAttachments: this.formBuilder.array([]),
      }),
      TabFive: this.formBuilder.group({
        AISSailingDate: ['', [Validators.required]],
        AISArrivalDate: ['', [Validators.required]],
        AISOriginPort: ['', [Validators.required]],
        AISDestinationPort: ['', [Validators.required]],
        Remarks: [''],
        AISVoyageStoppageDetails: this.formBuilder.array([]),
        AISAttachments: this.formBuilder.array([]),
      }),
      TabSix: this.formBuilder.group({
        VesselName: [''],
        RebateFileNumber: [''],
        BaseRequestCreationDate: [''],
        DocumnetedSailingDate: [''],
        TransitDate: [''],
        DatesOfReceivingLastAgentCorrespondence: [''],
        VoyageCertificatesOriginPort: [''],
        VoyageCertificatesDestinationPort: [''],
        TransitRebatePercentage: [''],
        RebateAmountAsPerInvoice: [''],
        transitAgentName: [''],
        IsException: []
      })
    });
    this.initiateworkflowForm = this.formBuilder.group({
      selectinitiateworkflow: [''],
      Admins: [null, [Validators.required]],
      Note: [null],
      Reason: [null, [Validators.required]],
    });
    this.WorkflowActionForm = this.formBuilder.group({
      workflowDecision: [''],
      Admins: [null, [Validators.required]],

    });
    this.noteAndReasons = this.formBuilder.group({
      Note: [null],
      Reason: [null, [Validators.required]],
    });

    //this.addDocsAttachments();
    //this.addAISAttachments();

  }
  fillForm() {

    this.releaseRequestForm.controls['TabOne'].get('BaseRequestRequestNumber').disable();
    //this.releaseRequestForm.controls['TabOne'].get('BaseRequestRequestNumber').updateValueAndValidity();
    this.releaseRequestForm.controls['TabOne'].get('RebateFileNumber').disable();
    this.releaseRequestForm.controls['TabOne'].get('IMONo').disable();
    this.releaseRequestForm.controls['TabOne'].get('RequestorName').disable();
    this.releaseRequestForm.controls['TabOne'].get('BaseRequestCreationDate').disable();

    this.releaseRequestForm.controls['TabTwo'].get('DWT').disable();
    this.releaseRequestForm.controls['TabTwo'].get('SCNT').disable();
    this.releaseRequestForm.controls['TabTwo'].get('AcceptDataRateId').disable();
    this.releaseRequestForm.controls['TabTwo'].get('ExtraCost').disable();
    this.releaseRequestForm.controls['TabTwo'].get('FormulateDecisionDate').disable();
    this.releaseRequestForm.controls['TabTwo'].get('OriginPort').disable();
    this.releaseRequestForm.controls['TabTwo'].get('DestinationPort').disable();
    this.releaseRequestForm.controls['TabTwo'].get('RebatePercentage').disable();
    //this.releaseRequestForm.controls['TabThree'].get('TransitagentText').disable();

    this.releaseRequestForm.controls['TabSix'].get('VesselName').disable();
    this.releaseRequestForm.controls['TabSix'].get('RebateFileNumber').disable();
    this.releaseRequestForm.controls['TabSix'].get('BaseRequestCreationDate').disable();
    this.releaseRequestForm.controls['TabSix'].get('DocumnetedSailingDate').disable();
    this.releaseRequestForm.controls['TabSix'].get('TransitDate').disable();
    this.releaseRequestForm.controls['TabSix'].get('DatesOfReceivingLastAgentCorrespondence').disable();
    this.releaseRequestForm.controls['TabSix'].get('VoyageCertificatesOriginPort').disable();
    this.releaseRequestForm.controls['TabSix'].get('VoyageCertificatesDestinationPort').disable();
    this.releaseRequestForm.controls['TabSix'].get('TransitRebatePercentage').disable();
    this.releaseRequestForm.controls['TabSix'].get('RebateAmountAsPerInvoice').disable();
    this.releaseRequestForm.controls['TabSix'].get('transitAgentName').disable();
    this.releaseRequestForm.controls['TabSix'].get('IsException').disable();

    if (this.rebateRequestLoaded.ReleaseFormAttachment != null) {
      if (this.rebateRequestLoaded.ReleaseFormAttachment.length > 0) {
        this.showDelete = true;
        this.showPDF = true;
        this.AttachmentView = true;
      }
      else {
        //this.showDelete = false;

        this.showPDF = false;
        this.AttachmentView = false;

      }
    }
    if (this.rebateRequestLoaded.Actualvoyage.toString() === "00000000-0000-0000-0000-000000000000") {
      this.Actualvoyage = "";
    }
    else {

      this.Actualvoyage = this.rebateRequestLoaded.Actualvoyage.toString();

    }
    let isShipLoaded: string = this.rebateRequestLoaded.IsShipLoaded ? "true" : "false";
    let isCircular: string = this.rebateRequestLoaded.IsCircular ? "true" : "false";
    let isException: string = this.rebateRequestLoaded.IsException ? "true" : "false";

    this.releaseRequestForm.controls['TabOne'].patchValue({
      PrincipalName: this.rebateRequestLoaded.PrincipalName,
      PrincipalEmail: this.rebateRequestLoaded.PrincipalEmail,
      VesselName: this.rebateRequestLoaded.VesselName,
      PrincipalFax: this.rebateRequestLoaded.PrincipalFax,
      RequestorName: this.rebateRequestLoaded.RequestorName,
      RequestorEmail: this.rebateRequestLoaded.RequestorEmail,
      RequestorFax: this.rebateRequestLoaded.RequestorFax,
      BaseRequestCreationDate: new Date(this.rebateRequestLoaded.BaseRequestCreationDate),
      BaseRequestRequestNumber: this.rebateRequestLoaded.BaseRequestRequestNumber,
      IMONo: this.rebateRequestLoaded.IMONo,
      RebateFileNumber: this.rebateRequestLoaded.RebateFileNumber,
    });
    this.releaseRequestForm.controls['TabTwo'].patchValue({
      SCNT: this.rebateRequestLoaded.SCNT,
      DWT: this.rebateRequestLoaded.DWT,
      AcceptDataRateId: this.rebateRequestLoaded.AcceptDataRateId,
      ExtraCost: this.rebateRequestLoaded.ExtraCost,
      FormulateDecisionDate: new Date(this.rebateRequestLoaded.FormulateDecisionDate),
      Actualvoyage: this.Actualvoyage,
      OriginPort: this.rebateRequestLoaded.OriginPort,
      DestinationPort: this.rebateRequestLoaded.DestinationPort,
      RebatePercentage: this.rebateRequestLoaded.RebatePercentage,


    });

    this.releaseRequestForm.controls['TabThree'].patchValue({
      IsShipLoaded: isShipLoaded,
      IsCircular: isCircular,
      CircularName:this.rebateRequestLoaded.CircularName,
      ExceptionNote:this.rebateRequestLoaded.ExceptionNote,
      IsException: isException,
      TransitagentFax: this.TransitagentFax,
      //Transitagent: this.Transitagent,
      transitAgentName: this.rebateRequestLoaded.transitAgentName,
      TransitagentEmail: this.rebateRequestLoaded.TransitagentEmail,
      TransitSCNT: this.rebateRequestLoaded.TransitSCNT,
      TransitDWT: this.rebateRequestLoaded.TransitDWT,
      TransitDate: this.rebateRequestLoaded.TransitDate === null ? "" : new Date(this.rebateRequestLoaded.TransitDate),
      TransitRateId: this.rebateRequestLoaded.TransitRateId,
      VesselTypeId: this.rebateRequestLoaded.VesselTypeId,
      //TransitagentText: this.Transitagent,
      TransitRebatePercentage: this.rebateRequestLoaded.TransitRebatePercentage,
      ActualRebatePercentage: this.rebateRequestLoaded.ActualRebatePercentage,
      RebateAmountAsPerInvoice: this.rebateRequestLoaded.RebateAmountAsPerInvoice,
      ActualRebateAmount: this.rebateRequestLoaded.ActualRebateAmount,
      DiffAmount: this.rebateRequestLoaded.DiffAmount,
      InvoiceNo: this.rebateRequestLoaded.InvoiceNo,
      Currency: this.rebateRequestLoaded.Currency,

      //TransitagentFax:this.rebateRequestLoaded.TransitagentFax,

    });

    this.releaseRequestForm.controls['TabFour'].patchValue({
      DateofLastAgentCorrespondence: this.rebateRequestLoaded.DateofLastAgentCorrespondence === null ? "" : new Date(this.rebateRequestLoaded.DateofLastAgentCorrespondence),
      DatesOfReceivingLastAgentCorrespondence: this.rebateRequestLoaded.DatesOfReceivingLastAgentCorrespondence === null ? "" : new Date(this.rebateRequestLoaded.DatesOfReceivingLastAgentCorrespondence),
      //DateOfLastReceivedDocuments: this.rebateRequestLoaded.DateOfLastReceivedDocuments,
      DocumnetedSailingDate: this.rebateRequestLoaded.DocumnetedSailingDate === null ? "" : new Date(this.rebateRequestLoaded.DocumnetedSailingDate),
      DocumnetedArrivalDate: this.rebateRequestLoaded.DocumnetedArrivalDate === null ? "" : new Date(this.rebateRequestLoaded.DocumnetedArrivalDate),
      VoyageCertificatesDestinationPort: this.rebateRequestLoaded.VoyageCertificatesDestinationPort,
      VoyageCertificatesOriginPort: this.rebateRequestLoaded.VoyageCertificatesOriginPort,


    });
    this.releaseRequestForm.controls['TabFive'].patchValue({
      AISOriginPort: this.rebateRequestLoaded.AISOriginPort,
      AISDestinationPort: this.rebateRequestLoaded.AISDestinationPort,
      Remarks: this.rebateRequestLoaded.Remarks,
      AISSailingDate: this.rebateRequestLoaded.AISSailingDate === null ? "" : new Date(this.rebateRequestLoaded.AISSailingDate),
      AISArrivalDate: this.rebateRequestLoaded.AISArrivalDate === null ? "" : new Date(this.rebateRequestLoaded.AISArrivalDate),
    });

    this.releaseRequestForm.controls['TabSix'].patchValue({
      VesselName: this.rebateRequestLoaded.VesselName,
      RebateFileNumber: this.rebateRequestLoaded.RebateFileNumber,
      BaseRequestCreationDate: new Date(this.rebateRequestLoaded.BaseRequestCreationDate),
      DocumnetedSailingDate: this.rebateRequestLoaded.DocumnetedSailingDate === null ? "" : new Date(this.rebateRequestLoaded.DocumnetedSailingDate),
      TransitDate: this.rebateRequestLoaded.TransitDate === null ? "" : new Date(this.rebateRequestLoaded.TransitDate),
      DatesOfReceivingLastAgentCorrespondence: this.rebateRequestLoaded.DatesOfReceivingLastAgentCorrespondence === null ? "" : new Date(this.rebateRequestLoaded.DatesOfReceivingLastAgentCorrespondence),
      VoyageCertificatesDestinationPort: this.rebateRequestLoaded.VoyageCertificatesDestinationPort,
      VoyageCertificatesOriginPort: this.rebateRequestLoaded.VoyageCertificatesOriginPort,
      TransitagentText: this.Transitagent,
      TransitRebatePercentage: this.rebateRequestLoaded.TransitRebatePercentage,
      transitAgentName: this.rebateRequestLoaded.transitAgentName,
      RebateAmountAsPerInvoice: this.rebateRequestLoaded.RebateAmountAsPerInvoice,
      IsException: isException,

    });
    if (this.rebateRequestLoaded.Actualvoyage.toString() === "00000000-0000-0000-0000-000000000000") {
      // this.Actualvoyage = "";
    }
    else {

      //this.Actualvoyage = this.rebateRequestLoaded.Actualvoyage.toString();
      this.ActualVoyageChange(this.rebateRequestLoaded.Actualvoyage);
      //this.selectedoption = this.LongHaulRequestOptionsFormulatedDecision.find(i => i.Id === this.Actualvoyage);
    }
    if (this.isRefundWorkflow || this.isRestudyWorkflow) {
      this.noteAndReasons.patchValue({
        Reason: this.rebateRequestLoaded.SelectedReason,
        Note: this.rebateRequestLoaded.ReleaseFormDecisionNote,
      });
      if (this.isMoreInfo) {
        this.noteAndReasons.enable();
        this.noteAndReasons.reset();

      }
      else {
        this.noteAndReasons.disable();
      }
    }
    if(this.currentRoute != "ReleaseForm"){
      this.showdeleteVoyage = false;
      this.showDelete = false;
    }
    //this.addVoyageStoppage();
    //this.AISaddVoyageStoppage();
  }

  get AISAttachments() {
    return this.releaseRequestForm.controls['TabFive'].get('AISAttachments') as FormArray;
  }
  get attachment(): FormGroup {
    return this.formBuilder.group({
      DocumentName: '',
      URL: '',
      AttachmentTypeId: ''
    });
  }
  deleteDocsAttachments(index: number, progressVariableName) {
    this[progressVariableName] = 0;
    this.DocsAttachments.removeAt(index);
    this.DocsAttachment.splice(index, 1);
  }
  deleteAISAttachments(index: number, progressVariableName) {
    this[progressVariableName] = 0;
    this.AISAttachments.removeAt(index);
    this.AISAttachment.splice(index, 1);
  }

  bindDocsAttachments(attachments): any {
    let control = <FormArray>this.releaseRequestForm.controls['TabFour'].get('DocsAttachments');
    attachments.forEach((key) => {
      control.push(new FormGroup({
        DocumentName: new FormControl({ value: key.DocumentName, disabled: false }),
        URL: new FormControl({ value: key.URL, disabled: true }),
        AttachmentTypeId: new FormControl({ value: key.AttachmentTypeId, disabled: false }),
        Id: new FormControl({ value: key.Id, disabled: false })
      }));
    });

    return control;
  }
  bindAisAttachments(attachments): any {
    let control = <FormArray>this.releaseRequestForm.controls['TabFive'].get('AISAttachments');

    attachments.forEach((key) => {
      control.push(new FormGroup({
        DocumentName: new FormControl({ value: key.DocumentName, disabled: false }),
        URL: new FormControl({ value: key.URL, disabled: true }),
        AttachmentTypeId: new FormControl({ value: key.AttachmentTypeId, disabled: false }),
        Id: new FormControl({ value: key.Id, disabled: false })
      }));
    });

    return control;
  }

  getCurrentDocAttchment(index) {
    if (this.DocsAttachment.length > 0) {
      this.currenctDocAttachment = this.DocsAttachment[index];
    }
  }
  getCurrentAISAttchment(index) {
    if (this.AISAttachment.length > 0) {
      this.currenctAISAttachment = this.AISAttachment[index];
    }
  }


  public onFileSelected(event, currFormControl, index, progressVariableName, type) {
    this[progressVariableName] = 0;
    let percentDone = 0;

    if (!this.fileService.IsFileExtentionValid(event)) {
      currFormControl.setValue("");
      this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').subscribe((res: string) => {
        this.alertService.error(res);
        let invalidElements = document.getElementsByClassName('alert-danger');
        event.target.value = "";
        window.scrollTo(0, 0);
        return false;
      });
    }

    else if (!this.fileService.IsFileSizeValid(event)) {
      currFormControl.setValue("");
      this.translate.get('FRONT_USER.NotAllowedFileSize').subscribe((res: string) => {
        this.alertService.error(res);
        let invalidElements = document.getElementsByClassName('alert-danger');
        event.target.value = "";
        window.scrollTo(0, 0);
        return false;
      });
    }
    else {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('File', file);
      let donName = file.name.split('.').slice(0, -1).join('.')
      formData.append('DocumentName', donName);
      formData.append('FolderName', this.uploadFolder);
      this.fileService.fileUploader(formData).subscribe(
        event => {
          if (event.type === HttpEventType.UploadProgress) {
            percentDone = Math.round(100 * event.loaded / event.total)
            this[progressVariableName] = percentDone;
            currFormControl.setErrors({ notCompleted: true });
          } else if (event instanceof HttpResponse) {
            var jsonResponse = event.body.Data;
            var Url = jsonResponse.Url;
            currFormControl.setValue(Url);
            currFormControl.setErrors(null);
            currFormControl.updateValueAndValidity();
            if (type == 'D') {
              let x = new ReleaseFormAttachment();
              x.AttachmentTypeId = 41;
              x.DocumentName = donName;
              x.URL = Url;
              this.DocsAttachment.push(x);
            }
            else if (type == 'A') {
              let f = new ReleaseFormAttachment();
              f.AttachmentTypeId = 42;
              f.DocumentName = donName;
              f.URL = Url;
              this.AISAttachment.push(f);
            }
          }
        }
      );
    }
  }


  get DocsAttachments() {

    return this.releaseRequestForm.controls['TabFour'].get('DocsAttachments') as FormArray;
  }
  get DocsAttachmentsLenth() {
    return this.releaseRequestForm.controls['TabFour'].get('DocsAttachments') as FormArray;
  }
  get getAttachmentsGetter() {
    return this.releaseRequestForm.controls['TabFour'].get('DocsAttachments').value;
  }

  get getAttachmentsLengthGetter() {
    return this.getAttachmentsGetter.length;
  }




  get getAISAttachmentsGetter() {
    return this.releaseRequestForm.controls['TabFive'].get('AISAttachments').value;
  }

  get getAISAttachmentsLengthGetter() {
    return this.getAISAttachmentsGetter.length;
  }
  addDocsAttachments() {
    let control = <FormArray>this.releaseRequestForm.controls['TabFour'].get('DocsAttachments');
    control.push(new FormGroup({
      DocumentName: new FormControl('', Validators.required),
      URL: new FormControl('', FileValidator.validate),
      AttachmentTypeId: new FormControl(''),
      Id: new FormControl('')
    }));
    return control;

  }
  addAISAttachments() {
    let control = <FormArray>this.releaseRequestForm.controls['TabFive'].get('AISAttachments');
    control.push(new FormGroup({
      DocumentName: new FormControl('', Validators.required),
      URL: new FormControl('', FileValidator.validate),
      AttachmentTypeId: new FormControl(''),
      Id: new FormControl('')
    }));
    return control;
  }
  getRebateRequestOptions(): void {

    //here  LongHaulRequestOptionsFormulatedDecision
    this.longHaulRequestRequestorDecisionRequest.LongHaulRequestId = this.rebateRequestId || this.rebateRequestLoaded.BaseRequestRequestId || this.rebateRequestLoaded.BaseRequest.Id;
    for (let i: number = 0; i < this.longHaulRequestOptions.length; i++) {
      this.longHaulRequestRequestorDecisionRequest.LongHaulRequestOptionsFormulatedDecision[i] = new LongHaulRequestOptionFormulatedDecision();
      this.longHaulRequestRequestorDecisionRequest.LongHaulRequestOptionsFormulatedDecision[i].Id = this.longHaulRequestOptions[i].Id;
    }
    this.getRebateRequestRequestorDecision();
  }
  getRebateRequestRequestorDecision(): void {

    this.longHaulRequestRequestorDecisionRequest.IsFormulatedDecisionComponent = false;
    this.longHaulService.getRebateRequestToFormulateDecision(this.longHaulRequestRequestorDecisionRequest).subscribe(
      data => this.getRequestRequestorDecisionResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getRebateRequestRequestorDecisionCompleted()
    );
  }
  getRebateRequestRequestorDecisionCompleted(): void {

    if (this.getRequestRequestorDecisionResponseObject.Success) {
      this.longHaulRequestRequestorDecisionResponse = this.getRequestRequestorDecisionResponseObject.Data as LongHaulRequestFormulateDecision;
      this.LongHaulRequestOptionsFormulatedDecision = this.longHaulRequestRequestorDecisionResponse.LongHaulRequestOptionsFormulatedDecision;

      this.fillForm();
      if (this.isRefundWorkflow) {
        this.showReasonCol = false;
        this.showTableInWF();

      } else if (this.isRestudyWorkflow) {
        this.showReasonCol = false;
        this.showTableInWF();

      }
    }
  }

  loadAgentsDisplayNames(keyWord: string) {

    this.isAutoCompleteLoading = true;

    this.agentSrv.GetAgentsAllInfoByDisplayName(keyWord).subscribe(s => {
      this.agentsNamesList = [];
      this.agentsData = s.Data;
      s.Data.forEach(element => {
        this.agentsNamesList.push(element.Name)
      });
      // this.agentsNamesList = s.Data;
      this.isAutoCompleteLoading = false;
    });
  }
  onAgentsNamesSearchChange(val: string) {
    this.loadAgentsDisplayNames(val);
  }

  ActualVoyageChange(optionId: number): void {

    this.selectedoption = this.LongHaulRequestOptionsFormulatedDecision.find(i => i.Id === optionId);
    this.releaseRequestForm.controls['TabTwo'].patchValue({
      OriginPort: this.selectedoption.LastPortOfOrigin,
      DestinationPort: this.selectedoption.FirstPortOfDestination,
      RebatePercentage: this.selectedoption.RebatePercentage,
    });


  }
  onActualVoyageChange(optionId: number): void {
    this.selectedoption = this.LongHaulRequestOptionsFormulatedDecision.find(i => i.Id === optionId);
    this.releaseRequestForm.controls['TabTwo'].patchValue({
      OriginPort: this.selectedoption.LastPortOfOrigin,
      DestinationPort: this.selectedoption.FirstPortOfDestination,
      RebatePercentage: this.selectedoption.RebatePercentage,
    });
    this.releaseRequestForm.controls['TabFour'].patchValue({
      VoyageCertificatesOriginPort: this.selectedoption.LastPortOfOrigin,
      VoyageCertificatesDestinationPort: this.selectedoption.FirstPortOfDestination,
    });
    this.releaseRequestForm.controls['TabFive'].patchValue({
      AISDestinationPort: this.selectedoption.FirstPortOfDestination,
      AISOriginPort: this.selectedoption.LastPortOfOrigin,
    });
    this.releaseRequestForm.controls['TabThree'].patchValue({
      TransitRebatePercentage: this.selectedoption.RebatePercentage,
      // ActualRebatePercentage: this.selectedoption.RebatePercentage,
    });
  }
  onAgentNameCleared() {
    this.TransitagentId = '';
    this.releaseRequestForm.controls['TabThree'].get('TransitagentEmail').setValue('');
    this.releaseRequestForm.controls['TabThree'].get('TransitagentFax').setValue('');
  }
  selectAgentNameEvent(item) {

    this.TransitagentEmail = "";
    this.TransitagentFax = "";
    this.Transitagent = item;
    let selectedAgent = this.agentsData.find(i => i.Name === item);
    this.TransitagentId = selectedAgent.UserId;
    this.membershipService.GetAspUser(selectedAgent.UserId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObject = resObj;
        if (this.responseObject.Success) {
          this.TransitagentEmail = resObj.Data['Email'];
          this.TransitagentFax = selectedAgent.Fax;

          this.releaseRequestForm.controls['TabThree'].patchValue({
            TransitagentFax: this.TransitagentFax,
            TransitagentEmail: this.TransitagentEmail,
            transitAgentName: selectedAgent.DisplayName,
          });

        }
        else {

        }
      });

  }
  public getAgent(agentId: string) {
    this.agentSrv.GetAgent(agentId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObject = resObj;
        if (this.responseObject.Success) {
          if (!resObj.Data.IsOffline) {
            resObj.Data.AgentCurrencies = resObj.Data.AgentCurrencies.filter(item => item.TreasuryNumber != null);
          }
          this.TransitagentId = resObj.Data['UserId'];
          this.Transitagent = resObj.Data['Name'];
          this.releaseRequestForm.controls['TabThree'].patchValue({
            // Transitagent : this.Transitagent,
            Transitagent: resObj.Data['Name'],
            TransitagentFax: resObj.Data['Fax'],
            Currency: this.rebateRequestLoaded.Currency,


          });
          this.loadAgentsDisplayNames(resObj.Data['Name']);
          /*this.AgentCurrencies = resObj.Data['AgentCurrencies'].map(function (obj) {
            return {
              Id: obj.Currency.Id,
              NameEN: obj.Currency.NameEN + "-" + obj.TreasuryNumber,
              NameAR: obj.Currency.NameAR + "-" + obj.TreasuryNumber,
              TreasuryNumber: obj.TreasuryNumber
            }
          });*/
        }
      });

    if (this.rebateRequestLoaded.TransitagentEmail != '') {
      this.membershipService.GetAspUser(agentId).subscribe(
        (resObj: ResponseObject) => {
          this.responseObject = resObj;
          if (this.responseObject.Success) {
            // this.TransitagentEmail = resObj.Data['Email'];
            this.releaseRequestForm.controls['TabThree'].patchValue({
              TransitagentEmail: this.rebateRequestLoaded.TransitagentEmail,

              Currency: this.rebateRequestLoaded.Currency,
            });
          }
        });

    }
    else {
      this.membershipService.GetAspUser(agentId).subscribe(
        (resObj: ResponseObject) => {
          this.responseObject = resObj;
          if (this.responseObject.Success) {
            this.TransitagentEmail = resObj.Data['Email'];
            this.releaseRequestForm.controls['TabThree'].patchValue({
              TransitagentEmail: this.TransitagentEmail,
              Currency: this.rebateRequestLoaded.Currency,
            });
          }

        });
    }




    if (this.AgentCurrencies.length == 0) {
      this.portalSrv.GetPortalUser(agentId)
        .subscribe((data: ResponseObject) => {
          if (data.Data != null) {
            this.TransitagentId = data.Data['UserId'],
              this.releaseRequestForm.controls['TabThree'].patchValue({
                // Transitagent : data.Data['FullName']
                Transitagent: data.Data['FullName'],
                TransitagentFax: data.Data['Fax'],
                TransitagentEmail: data.Data['Email'],
                Currency: this.rebateRequestLoaded.Currency,

              });
          }
        });
      this.lookupService.getCurrencies()
        .subscribe((data: ResponseObject) => {
          this.AgentCurrencies = data.Data as GenericLookup[];
        });
    }



  }
  onFocused(e) {
  }
  get AISVoyageStoppageDetails() {
    return this.releaseRequestForm.controls['TabFive'].get('AISVoyageStoppageDetails') as FormArray;
  }
  get AISVoyageStoppageDetailsLength() {
    return this.releaseRequestForm.controls['TabFive'].get('AISVoyageStoppageDetails') as FormArray;
  }
  AISdeleteVoyageStoppage(index: number) {
    this.AISVoyageStoppageDetails.removeAt(index);
  }
  AISaddVoyageStoppage() {
    let control;
    control = <FormArray>this.releaseRequestForm.controls['TabFive'].get('AISVoyageStoppageDetails');
    control.push(new FormGroup({
      AISStoppagePortName: new FormControl('',),
      AISStoppageStartDate: new FormControl('',),
      AISStoppageEndDate: new FormControl('',),
      Id: new FormControl('')
    }));
  }
  later(): void {
    this.router.navigateByUrl('/longHaulReport');
  }

  get VoyageStoppageDetails() {

    return this.releaseRequestForm.controls['TabFour'].get('VoyageStoppageDetails') as FormArray;
  }
  get VoyageStoppageDetailsLength() {
    return this.releaseRequestForm.controls['TabFour'].get('VoyageStoppageDetails') as FormArray;
  }

  deleteVoyageStoppage(index: number) {
    this.VoyageStoppageDetails.removeAt(index);
  }
  addVoyageStoppage() {
    let control;
    control = <FormArray>this.releaseRequestForm.controls['TabFour'].get('VoyageStoppageDetails');
    control.push(new FormGroup({
      StoppagePortName: new FormControl('',),
      StoppageReason: new FormControl('',),
      StoppageStartDate: new FormControl('',),
      StoppageEndDate: new FormControl('',),
      Id: new FormControl('')
    }));
  }

  submitReleaseRequest() {

    this.longHaulService.submitReleaseRequest(this.relaseRequestObject).subscribe(
      data => this.submitReleaseRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitReleaseRequestCompleted()
    );
  }
  get selectedRowsText(): string {

    return this.selectedRows
      .map(row => JSON.stringify(row))
      .join('\n');
  }
  stripKeysAsString(jsonStr: string[]): string {
    try {
      let x;
      jsonStr.forEach(element => {
        const obj = JSON.parse(element);
        x += obj;
      });
      //const obj = JSON.parse(jsonStr);
      return Object.values(x).join(",");
    } catch (e) {
      console.error("Invalid JSON:", e);
      return "";
    }
  }
  onRowSelect(event: any, row: any) {
    let x = this.selectedRowsText;
    if (event.target.checked) {
      this.selectedRows.push(row.Field);
    } else {
      this.selectedRows = this.selectedRows.filter(r => r !== row.Field);
    }
    this.initiateworkflowForm.patchValue({
      Reason: this.selectedRowsText,
    });
    if (this.isMoreInfo) {
      this.noteAndReasons.patchValue({
        Reason: this.selectedRowsText,
      });
    }
  }
  showTableInWF() {

    this.selectedRate = this.rates.find(i => i.Id == this.getReleaseFormResponseObject.Data.TransitRateId);
    this.selectedvesselType = this.vesselTypes.find(i => i.Id == this.getReleaseFormResponseObject.Data.VesselTypeId);
    this.selectedoption = this.LongHaulRequestOptionsFormulatedDecision.find(i => i.Id === this.getReleaseFormResponseObject.Data.Actualvoyage);
    if (this.selectedoption.LastPortOfOrigin != this.releaseRequestForm.controls['TabTwo'].get('OriginPort').value) {
      let x = new Diff;
      x.Field = 'Measurement Decision Details - Origin port';
      x.Formula = 'changed';
      x.NewData = this.releaseRequestForm.controls['TabTwo'].get('OriginPort').value;
      this.diffsObjects.push(x);
    }

    if (this.selectedoption.FirstPortOfDestination != this.releaseRequestForm.controls['TabTwo'].get('DestinationPort').value) {
      let y = new Diff;
      y.Field = 'Measurement Decision Details - Destination Port';
      y.Formula = 'changed';
      y.NewData = this.releaseRequestForm.controls['TabTwo'].get('DestinationPort').value;
      this.diffsObjects.push(y);
    }
    if (this.releaseRequestForm.controls['TabThree'].get('ActualRebateAmount').value != "") {
      if (this.releaseRequestForm.controls['TabThree'].get('ActualRebateAmount').value != this.releaseRequestForm.controls['TabThree'].get('RebateAmountAsPerInvoice').value) {
        let y = new Diff;
        y.Field = 'Transit Details - Actual Rebate Amount';
        y.Formula = 'changed';
        y.NewData = this.releaseRequestForm.controls['TabThree'].get('ActualRebateAmount').value;
        this.diffsObjects.push(y);
      }
    }
    this.comparetransitdate()
    if (this.releaseRequestForm.controls['TabThree'].get('TransitRateId').value != this.releaseRequestForm.controls['TabTwo'].get('AcceptDataRateId').value) {
      let z = new Diff;
      z.Field = 'Transit Details - Transit rate';
      z.Formula = 'changed';
      z.NewData = this.selectedRate.NameEN;//todo new rate not old one
      this.diffsObjects.push(z);
    }
    if (Number(this.releaseRequestForm.controls['TabThree'].get('VesselTypeId').value) != this.rebateRequestLoaded.VesselTypeId) {
      let b = new Diff;
      b.Field = 'Transit Details - VesselType';
      b.Formula = 'Not Equal Accept Data';
      b.NewData = this.selectedvesselType.NameEN;
      this.diffsObjects.push(b);
    }
    if (Number(this.releaseRequestForm.controls['TabThree'].get('TransitSCNT').value) < Number(this.releaseRequestForm.controls['TabTwo'].get('SCNT').value)) {
      let a = new Diff;
      a.Field = 'Transit Details - Transit net tonnage';
      a.Formula = '< accept data';
      a.NewData = this.releaseRequestForm.controls['TabThree'].get('TransitSCNT').value;
      this.diffsObjects.push(a);
    }
    if (Number(this.releaseRequestForm.controls['TabThree'].get('TransitDWT').value) != Number(this.releaseRequestForm.controls['TabTwo'].get('DWT').value)) {
      let b = new Diff;
      b.Field = 'Transit Details - Transit DWT';
      b.Formula = 'Not Equal Accept Data';
      b.NewData = this.releaseRequestForm.controls['TabThree'].get('TransitDWT').value;
      this.diffsObjects.push(b);
    }

    if (this.selectedoption.LastPortOfOrigin != this.releaseRequestForm.controls['TabFour'].get('VoyageCertificatesOriginPort').value) {
      let x = new Diff;
      x.Field = 'Voyage Certificates - Origin port';
      x.Formula = 'changed';
      x.NewData = this.releaseRequestForm.controls['TabFour'].get('VoyageCertificatesOriginPort').value;
      this.diffsObjects.push(x);
    }

    if (this.selectedoption.FirstPortOfDestination != this.releaseRequestForm.controls['TabFour'].get('VoyageCertificatesDestinationPort').value) {
      let y = new Diff;
      y.Field = 'Voyage Certificates - Destination Port';
      y.Formula = 'changed';
      y.NewData = this.releaseRequestForm.controls['TabFour'].get('VoyageCertificatesDestinationPort').value;
      this.diffsObjects.push(y);
    }




    //this.comparelastReceivedDocuments();
    this.compareSailingDate();
    this.compareSailingDateAIS();

    this.AISVoyageStoppageDetails.controls.forEach(control => {
      let o = this.datePipe.transform(control.get('AISStoppageStartDate').value, "yyyy-MM-dd");
      let z = this.datePipe.transform(control.get('AISStoppageEndDate').value, "yyyy-MM-dd");
      if (o != null && z != null) {
        this.compareStoppageDate(o, z, 'A');
      }
    });
    this.VoyageStoppageDetails.controls.forEach(control => {
      let o = this.datePipe.transform(control.get('StoppageStartDate').value, "yyyy-MM-dd");
      let z = this.datePipe.transform(control.get('StoppageEndDate').value, "yyyy-MM-dd");
      if (o != null && z != null) {
        this.compareStoppageDate(o, z, 'C');
      }
    });
    this.toastr.clear();
    //this.toastr.success('Data Saved Successfully');
    // window.scrollTo(0, 1500);
  }
  showTable() {
    this.selectedRate = this.rates.find(i => i.Id == this.submitReleaseRequestResponseObject.Data.TransitRateId);
    this.selectedvesselType = this.vesselTypes.find(i => i.Id == this.submitReleaseRequestResponseObject.Data.VesselTypeId);
    this.selectedoption = this.LongHaulRequestOptionsFormulatedDecision.find(i => i.Id === this.submitReleaseRequestResponseObject.Data.Actualvoyage);
    if (this.releaseRequestForm.controls['TabThree'].get('ActualRebateAmount').value != "") {
      if (this.releaseRequestForm.controls['TabThree'].get('ActualRebateAmount').value != this.releaseRequestForm.controls['TabThree'].get('RebateAmountAsPerInvoice').value) {
        let y = new Diff;
        y.Field = 'Transit Details - Actual Rebate Amount';
        y.Formula = 'changed';
        y.NewData = this.releaseRequestForm.controls['TabThree'].get('ActualRebateAmount').value;
        this.diffsObjects.push(y);
      }
    }

    if (this.selectedoption.LastPortOfOrigin != this.releaseRequestForm.controls['TabTwo'].get('OriginPort').value) {
      let x = new Diff;
      x.Field = 'Measurement Decision Details - Origin port';
      x.Formula = 'changed';
      x.NewData = this.releaseRequestForm.controls['TabTwo'].get('OriginPort').value;
      this.diffsObjects.push(x);
    }
    if (this.selectedoption.LastPortOfOrigin != this.releaseRequestForm.controls['TabFour'].get('VoyageCertificatesOriginPort').value) {
      let x = new Diff;
      x.Field = 'Voyage Certificates - Origin port';
      x.Formula = 'changed';
      x.NewData = this.releaseRequestForm.controls['TabFour'].get('VoyageCertificatesOriginPort').value;
      this.diffsObjects.push(x);
    }

    if (this.selectedoption.FirstPortOfDestination != this.releaseRequestForm.controls['TabFour'].get('VoyageCertificatesDestinationPort').value) {
      let y = new Diff;
      y.Field = 'Voyage Certificates - Destination Port';
      y.Formula = 'changed';
      y.NewData = this.releaseRequestForm.controls['TabFour'].get('VoyageCertificatesDestinationPort').value;
      this.diffsObjects.push(y);
    }
    if (this.selectedoption.FirstPortOfDestination != this.releaseRequestForm.controls['TabTwo'].get('DestinationPort').value) {
      let y = new Diff;
      y.Field = 'Measurement Decision Details - Destination Port';
      y.Formula = 'changed';
      y.NewData = this.releaseRequestForm.controls['TabTwo'].get('DestinationPort').value;
      this.diffsObjects.push(y);
    }
    this.comparetransitdate()
    if (this.releaseRequestForm.controls['TabThree'].get('TransitRateId').value != this.releaseRequestForm.controls['TabTwo'].get('AcceptDataRateId').value) {
      let z = new Diff;
      z.Field = 'Transit Details - Transit rate';
      z.Formula = 'changed';
      z.NewData = this.selectedRate.NameEN;
      this.diffsObjects.push(z);
    }
    if (Number(this.releaseRequestForm.controls['TabThree'].get('VesselTypeId').value) != this.rebateRequestLoaded.VesselTypeId) {
      let b = new Diff;
      b.Field = 'Transit Details - VesselType';
      b.Formula = 'Not Equal Accept Data';
      b.NewData = this.selectedvesselType.NameEN;
      this.diffsObjects.push(b);
    }
    if (Number(this.releaseRequestForm.controls['TabThree'].get('TransitSCNT').value) < Number(this.releaseRequestForm.controls['TabTwo'].get('SCNT').value)) {
      let a = new Diff;
      a.Field = 'Transit Details - Transit net tonnage';
      a.Formula = '< accept data';
      a.NewData = this.releaseRequestForm.controls['TabThree'].get('TransitSCNT').value;
      this.diffsObjects.push(a);
    }
    if (Number(this.releaseRequestForm.controls['TabThree'].get('TransitDWT').value) != Number(this.releaseRequestForm.controls['TabTwo'].get('DWT').value)) {
      let b = new Diff;
      b.Field = 'Transit Details - Transit DWT';
      b.Formula = 'Not Equal Accept Data';
      b.NewData = this.releaseRequestForm.controls['TabThree'].get('TransitDWT').value;
      this.diffsObjects.push(b);
    }

    // this.comparelastReceivedDocuments();
    this.compareSailingDate();
    this.compareSailingDateAIS();

    this.AISVoyageStoppageDetails.controls.forEach(control => {
      let o = this.datePipe.transform(control.get('AISStoppageStartDate').value, "yyyy-MM-dd");
      let z = this.datePipe.transform(control.get('AISStoppageEndDate').value, "yyyy-MM-dd");
      if (o != null && z != null) {
        this.compareStoppageDate(o, z, 'A');
      }
    });
    this.VoyageStoppageDetails.controls.forEach(control => {
      let o = this.datePipe.transform(control.get('StoppageStartDate').value, "yyyy-MM-dd");
      let z = this.datePipe.transform(control.get('StoppageEndDate').value, "yyyy-MM-dd");
      if (o != null && z != null) {
        this.compareStoppageDate(o, z, 'C');
      }
    });
    this.toastr.clear();
    this.toastr.success('Data Saved Successfully');
    // window.scrollTo(0, 1500);
  }
  submitReleaseRequestCompleted(): void {
    this.showNotes = true;
    if (this.submitReleaseRequestResponseObject.Success) {
      //this.savedID = this.submitReleaseRequestResponseObject.Data.Id;
      this.ReleaseFormId = this.submitReleaseRequestResponseObject.Data.Id;
      this.isCalculated = true;
      if (this.isSave != true) {
        this.showTable();
      }
      else {
        this.toastr.clear();
        this.toastr.success('Data Saved Successfully');
        window.scrollTo(0, 490);
      }
    } else {
      this.toastr.clear();
      this.toastr.error('something went wrong');
      window.scrollTo(0, 490);
    }
    //this.isFormValid = true;
    this.globalServices.isLoaderEnabled = false;
  }
  Save() {
    this.requestAttachments = [];
    this.requestStoppage = [];
    this.isSave = true;
    this.relaseRequestObject = { ...this.releaseRequestForm.controls['TabOne'].value, ...this.releaseRequestForm.controls['TabTwo'].value, ...this.releaseRequestForm.controls['TabThree'].value, ...this.releaseRequestForm.controls['TabFour'].value, ...this.releaseRequestForm.controls['TabFive'].value };
    this.relaseRequestObject.RequestorId = this.RequestorId;
    this.relaseRequestObject.RequestorEmail = this.rebateRequestLoaded.RequestorEmail
    this.VoyageStoppageDetails.controls.forEach(control => {
      let o = this.datePipe.transform(control.get('StoppageStartDate').value, "yyyy-MM-dd");
      let z = this.datePipe.transform(control.get('StoppageEndDate').value, "yyyy-MM-dd");
      let x = new Stoppage();
      x.StartDate = o;
      x.EndDate = z;
      x.Reason = control.get('StoppageReason').value;
      x.PortName = control.get('StoppagePortName').value;
      x.TYPE = 'Certificates';
      this.requestStoppage.push(x);
    });
    this.AISVoyageStoppageDetails.controls.forEach(control => {
      let o = this.datePipe.transform(control.get('AISStoppageStartDate').value, "yyyy-MM-dd");
      let z = this.datePipe.transform(control.get('AISStoppageEndDate').value, "yyyy-MM-dd");
      let x = new Stoppage();
      x.StartDate = o;
      x.EndDate = z;
      x.PortName = control.get('AISStoppagePortName').value;
      x.TYPE = 'AIS';
      this.requestStoppage.push(x);
    });

    this.DocsAttachments.controls.forEach(control => {
      let D = new ReleaseFormAttachment();
      D.AttachmentTypeId = control.get('AttachmentTypeId').value;
      D.DocumentName = control.get('DocumentName').value;
      D.Id = control.get('Id').value;
      D.URL = control.get('URL').value;

      this.requestAttachments.push(D);
    });
    this.AISAttachments.controls.forEach(control => {
      let A = new ReleaseFormAttachment();
      A.AttachmentTypeId = control.get('AttachmentTypeId').value;
      A.DocumentName = control.get('DocumentName').value;
      A.Id = control.get('Id').value;
      A.URL = control.get('URL').value;

      this.requestAttachments.push(A);
    });




    this.relaseRequestObject = { ...this.releaseRequestForm.controls['TabOne'].value, ...this.releaseRequestForm.controls['TabTwo'].value, ...this.releaseRequestForm.controls['TabThree'].value, ...this.releaseRequestForm.controls['TabFour'].value, ...this.releaseRequestForm.controls['TabFive'].value };
    this.relaseRequestObject.ServiceId = 2;
    this.relaseRequestObject.StatusId = 1;
    this.relaseRequestObject.IsEditable = true;
    this.relaseRequestObject.RebateFileNumber = this.rebateRequestLoaded.RebateFileNumber;
    this.relaseRequestObject.BaseRequestCreationDate = this.rebateRequestLoaded.BaseRequestCreationDate;
    this.relaseRequestObject.Transitagent = this.TransitagentId;
    this.relaseRequestObject.IMONo = this.rebateRequestLoaded.IMONo;
    this.relaseRequestObject.DWT = this.rebateRequestLoaded.DWT;
    this.relaseRequestObject.SCNT = this.rebateRequestLoaded.SCNT;
    if (this.selectedoption) {
      this.relaseRequestObject.RebatePercentage = this.selectedoption.RebatePercentage;
      this.relaseRequestObject.OriginPort = this.selectedoption.LastPortOfOrigin;
      this.relaseRequestObject.DestinationPort = this.selectedoption.FirstPortOfDestination;
    }
    this.relaseRequestObject.ExtraCost = this.rebateRequestLoaded.ExtraCost;
    this.relaseRequestObject.AcceptDataRateId = this.rebateRequestLoaded.AcceptDataRateId;
    this.relaseRequestObject.FormulateDecisionDate = this.rebateRequestLoaded.FormulateDecisionDate;
    this.relaseRequestObject.BaseRequestRequestNumber = this.rebateRequestLoaded.BaseRequestRequestNumber;
    this.relaseRequestObject.RequestorName = this.rebateRequestLoaded.RequestorName;
    this.relaseRequestObject.BaseRequestRequestId = this.rebateRequestId || this.rebateRequestLoaded.BaseRequestRequestId || this.rebateRequestLoaded.BaseRequest.Id;
    this.relaseRequestObject.Stoppages = this.requestStoppage;
    this.relaseRequestObject.ReleaseFormAttachment = this.requestAttachments;
    debugger;
    this.relaseRequestObject.TransitDate = this.datePipe.transform(this.releaseRequestForm.controls['TabThree'].get('TransitDate').value, "yyyy-MM-dd");
    this.relaseRequestObject.DateofLastAgentCorrespondence = this.datePipe.transform(this.releaseRequestForm.controls['TabFour'].get('DateofLastAgentCorrespondence').value, "yyyy-MM-dd");
    this.relaseRequestObject.DatesOfReceivingLastAgentCorrespondence = this.datePipe.transform(this.releaseRequestForm.controls['TabFour'].get('DatesOfReceivingLastAgentCorrespondence').value, "yyyy-MM-dd");
    this.relaseRequestObject.DocumnetedSailingDate = this.datePipe.transform(this.releaseRequestForm.controls['TabFour'].get('DocumnetedSailingDate').value, "yyyy-MM-dd");
    this.relaseRequestObject.DocumnetedArrivalDate = this.datePipe.transform(this.releaseRequestForm.controls['TabFour'].get('DocumnetedArrivalDate').value, "yyyy-MM-dd");
    this.relaseRequestObject.AISSailingDate = this.datePipe.transform(this.releaseRequestForm.controls['TabFive'].get('AISSailingDate').value, "yyyy-MM-dd");
    this.relaseRequestObject.AISArrivalDate = this.datePipe.transform(this.releaseRequestForm.controls['TabFive'].get('AISArrivalDate').value, "yyyy-MM-dd");
    this.relaseRequestObject.transitAgentName = this.releaseRequestForm.controls['TabThree'].get('transitAgentName').value;


    //this.relaseRequestObject.IsSubmitClone = false;
    this.globalServices.isLoaderEnabled = true;
    if (this.savedID != "") {
      this.relaseRequestObject.Id = this.savedID;
    }
    this.showDelete = false;
    this.submitReleaseRequest();
  }
  Calculate() {
debugger;
debugger;
    const button = document.getElementById('ValidateBTN');
    if (button.textContent == 'Edit') {
      this.showSaveBtn = true;
      this.showdeleteVoyage = true;

      this.AttachmentView = true;
      this.showDelete = true;

      this.showAddAISVoyageStoppage = true;
      this.showAddVoyageStoppage = true;
      this.showAddAttachment = true;
    }


    if (this.isSubmitted == false) {
      this.showDelete = true;
      this.isTabOneSubmitted = true;
      this.isTabTwoSubmitted = true;
      this.isTabThreeSubmitted = true;
      this.isTabFourSubmitted = true;
      this.isTabFiveSubmitted = true;
      const tabOneInValidControls = this.tabOne.nativeElement.querySelectorAll('.ng-invalid');
      const tabTwoInValidControls = this.TabTwo.nativeElement.querySelectorAll('.ng-invalid');
      const tabThreeInValidControls = this.TabThree.nativeElement.querySelectorAll('.ng-invalid');
      const tabFourInValidControls = this.TabFour.nativeElement.querySelectorAll('.ng-invalid');
      const tabFiveInValidControls = this.TabFive.nativeElement.querySelectorAll('.ng-invalid');
      if (!this.releaseRequestForm.controls['TabOne'].valid && tabOneInValidControls.length > 0) {
        this.rebateRequestTabs.tabs[0].active = true;
        this.cd.detectChanges();
        if (tabOneInValidControls.length > 0)
          tabOneInValidControls[0].focus();
      }
      else if (!this.releaseRequestForm.controls['TabTwo'].valid && tabTwoInValidControls.length > 0) {
        this.rebateRequestTabs.tabs[1].active = true;
        this.cd.detectChanges();
        if (tabTwoInValidControls.length > 0)
          tabTwoInValidControls[0].focus();
      }
      else if (!this.releaseRequestForm.controls['TabThree'].valid && tabThreeInValidControls.length > 0) {
        this.rebateRequestTabs.tabs[2].active = true;
        this.cd.detectChanges();
        if (tabThreeInValidControls.length > 0)
          tabThreeInValidControls[0].focus();
      }
      else if (!this.releaseRequestForm.controls['TabFour'].valid && tabFourInValidControls.length > 0) {
        this.rebateRequestTabs.tabs[3].active = true;
        this.cd.detectChanges();
        if (tabFourInValidControls.length > 0)
          tabFourInValidControls[0].focus();
      }
      else if (!this.releaseRequestForm.controls['TabFive'].valid && tabFiveInValidControls.length > 0) {
        this.rebateRequestTabs.tabs[4].active = true;
        this.cd.detectChanges();
        if (tabFiveInValidControls.length > 0)
          tabFiveInValidControls[0].focus();
      }

      else {
        this.formMode == FormMode.Details;
        this.noteAndReasons.get('Reason')?.setValue("");
        //this.noteAndReasons.get('Note')?.setValue("");
        this.requestStoppage = [];
        this.requestAttachments = [];
        this.isSave = false;
        this.showSaveBtn = false;
        //this.showCircularName = false;
        this.showdeleteVoyage = false;
        this.AttachmentView = true;


        this.showAddVoyageStoppage = false;
        this.showAddAttachment = false;
        this.showAddAISVoyageStoppage = false;
        this.diffsObjects = [];
        this.showInfo = true;
        debugger;
        this.DocsAttachments.controls.forEach(control => {
          let D = new ReleaseFormAttachment();
          D.AttachmentTypeId = control.get('AttachmentTypeId').value;
          D.DocumentName = control.get('DocumentName').value;
          D.Id = control.get('Id').value;
          D.URL = control.get('URL').value;

          this.requestAttachments.push(D);
        });
        this.AISAttachments.controls.forEach(control => {
          let A = new ReleaseFormAttachment();
          A.AttachmentTypeId = control.get('AttachmentTypeId').value;
          A.DocumentName = control.get('DocumentName').value;
          A.Id = control.get('Id').value;
          A.URL = control.get('URL').value;

          this.requestAttachments.push(A);
        });
        // this.DocsAttachments.setControl('DocsAttachments', this.bindDocsAttachments(this.DocsAttachment));
        // this.AISAttachments.setControl('AISAttachments', this.bindAisAttachments(this.AISAttachment));
        this.VoyageStoppageDetails.controls.forEach(control => {
          let o = this.datePipe.transform(control.get('StoppageStartDate').value, "yyyy-MM-dd");
          let z = this.datePipe.transform(control.get('StoppageEndDate').value, "yyyy-MM-dd");
          let x = new Stoppage();
          x.StartDate = o;
          x.EndDate = z;
          x.Reason = control.get('StoppageReason').value;
          x.PortName = control.get('StoppagePortName').value;
          x.TYPE = 'Certificates';
          this.requestStoppage.push(x);
        });
        this.AISVoyageStoppageDetails.controls.forEach(control => {
          let o = this.datePipe.transform(control.get('AISStoppageStartDate').value, "yyyy-MM-dd");
          let z = this.datePipe.transform(control.get('AISStoppageEndDate').value, "yyyy-MM-dd");
          let x = new Stoppage();
          x.StartDate = o;
          x.EndDate = z;
          x.PortName = control.get('AISStoppagePortName').value;
          x.TYPE = 'AIS';
          this.requestStoppage.push(x);
        });
        /*if (this.releaseRequestForm.controls['TabThree'].get('TransitDate').value) {
          var selectedTransitDate = this.releaseRequestForm.controls['TabThree'].get('TransitDate').value.toLocaleString('en-US');
          this.releaseRequestForm.controls['TabThree'].get('TransitDate').setValue(selectedTransitDate);
        }*/
        this.relaseRequestObject = { ...this.releaseRequestForm.controls['TabOne'].value, ...this.releaseRequestForm.controls['TabTwo'].value, ...this.releaseRequestForm.controls['TabThree'].value, ...this.releaseRequestForm.controls['TabFour'].value, ...this.releaseRequestForm.controls['TabFive'].value };
        this.relaseRequestObject.RequestorId = this.RequestorId;
        this.relaseRequestObject.BaseRequestRequestId = this.rebateRequestId || this.rebateRequestLoaded.BaseRequestRequestId || this.rebateRequestLoaded.BaseRequest.Id;
        this.relaseRequestObject.RequestorEmail = this.rebateRequestLoaded.RequestorEmail;
        this.relaseRequestObject.ServiceId = 2;
        this.relaseRequestObject.StatusId = 1;
        this.relaseRequestObject.Transitagent = this.TransitagentId;
        this.relaseRequestObject.Stoppages = this.requestStoppage;
        this.relaseRequestObject.ReleaseFormAttachment = this.requestAttachments;
        this.relaseRequestObject.RebateFileNumber = this.rebateRequestLoaded.RebateFileNumber;
        this.relaseRequestObject.BaseRequestCreationDate = this.rebateRequestLoaded.BaseRequestCreationDate;
        this.relaseRequestObject.IMONo = this.rebateRequestLoaded.IMONo;
        this.relaseRequestObject.DWT = this.rebateRequestLoaded.DWT;
        this.relaseRequestObject.IMONo = this.rebateRequestLoaded.IMONo;
        this.relaseRequestObject.SCNT = this.rebateRequestLoaded.SCNT;
        this.relaseRequestObject.RebatePercentage = this.selectedoption.RebatePercentage;
        //this.relaseRequestObject.CircularName = this.releaseRequestForm.controls['TabThree'].get('CircularName').value;
        this.relaseRequestObject.OriginPort = this.selectedoption.LastPortOfOrigin;
        this.relaseRequestObject.DestinationPort = this.selectedoption.FirstPortOfDestination;
        this.relaseRequestObject.ExtraCost = this.rebateRequestLoaded.ExtraCost;
        this.relaseRequestObject.AcceptDataRateId = this.rebateRequestLoaded.AcceptDataRateId;
        this.relaseRequestObject.FormulateDecisionDate = this.rebateRequestLoaded.FormulateDecisionDate;
        this.relaseRequestObject.BaseRequestRequestNumber = this.rebateRequestLoaded.BaseRequestRequestNumber;
        this.relaseRequestObject.RequestorName = this.rebateRequestLoaded.RequestorName;
        this.relaseRequestObject.TransitDate = this.datePipe.transform(this.releaseRequestForm.controls['TabThree'].get('TransitDate').value, "yyyy-MM-dd");
        this.relaseRequestObject.DateofLastAgentCorrespondence = this.datePipe.transform(this.releaseRequestForm.controls['TabFour'].get('DateofLastAgentCorrespondence').value, "yyyy-MM-dd");
        this.relaseRequestObject.DatesOfReceivingLastAgentCorrespondence = this.datePipe.transform(this.releaseRequestForm.controls['TabFour'].get('DatesOfReceivingLastAgentCorrespondence').value, "yyyy-MM-dd");
        this.relaseRequestObject.DocumnetedSailingDate = this.datePipe.transform(this.releaseRequestForm.controls['TabFour'].get('DocumnetedSailingDate').value, "yyyy-MM-dd");
        this.relaseRequestObject.DocumnetedArrivalDate = this.datePipe.transform(this.releaseRequestForm.controls['TabFour'].get('DocumnetedArrivalDate').value, "yyyy-MM-dd");
        this.relaseRequestObject.AISSailingDate = this.datePipe.transform(this.releaseRequestForm.controls['TabFive'].get('AISSailingDate').value, "yyyy-MM-dd");
        this.relaseRequestObject.AISArrivalDate = this.datePipe.transform(this.releaseRequestForm.controls['TabFive'].get('AISArrivalDate').value, "yyyy-MM-dd");
        this.relaseRequestObject.transitAgentName = this.releaseRequestForm.controls['TabThree'].get('transitAgentName').value;

        //this.relaseRequestObject.IsSubmitClone = false;
        this.globalServices.isLoaderEnabled = true;
        if (this.savedID != "") {
          this.relaseRequestObject.Id = this.savedID;
        }
        this.releaseRequestForm.disable();
        this.showUpload= false;

        //this.isMoreInfo = false;
        this.showReasonCol = true;
        this.selectedRows = [];
        this.initiateworkflowForm.get('Reason')?.setValue("");
        this.noteAndReasons.enable();
        //const button = document.createElement('ValidateBTN');
        const button = document.getElementById('ValidateBTN');
        button.textContent = 'Edit';
        this.showDelete = false;
        this.showdeleteVoyage = false;
        this.AttachmentView = true;

        this.formMode == FormMode.Details;
        this.showAddVoyageStoppage = false;
        this.showAddAttachment = false;
        this.showAddAISVoyageStoppage = false;
        this.isSubmitted = true;
        this.submitReleaseRequest();
      }
    }

    else {
      this.releaseRequestForm.enable();
      //const button = document.createElement('ValidateBTN');
      const button = document.getElementById('ValidateBTN');
      button.textContent = 'Validate';
      this.showDelete = true;
      this.showUpload = true;
      this.showReasonCol = false;
      this.isSubmitted = false;
    }

  }
  getConfirmShipPassingObject(): void {
    this.longHaulService.getConfirmShipPassing(this.rebateRequestId).subscribe(
      data => this.getConfirmShipPassingObjectResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getConfirmShipPassingObjectCompleted()
    );
  }
  getConfirmShipPassingObjectCompleted(): void {
    if (this.getConfirmShipPassingObjectResponseObject.Success) {
      this.confirmShipPassingRequest = this.getConfirmShipPassingObjectResponseObject.Data as LongHaulRequestConfirmShipPassing;
      if (this.confirmShipPassingRequest.IsShipPassed) {
        this.ConfirmShipPassingTransitdate = this.confirmShipPassingRequest.PassingDate;
        this.releaseRequestForm.controls['TabThree'].patchValue({

          TransitDate: new Date(this.ConfirmShipPassingTransitdate).toLocaleString(),

        });
      }
    }
  }
  comparetransitdate() {
    let o = this.datePipe.transform(this.releaseRequestForm.controls['TabThree'].get('TransitDate').value, "yyyy-MM-dd");
    let v = this.datePipe.transform(this.releaseRequestForm.controls['TabTwo'].get('FormulateDecisionDate').value, "yyyy-MM-dd");
    const date2: Date = new Date(o);
    const date1: Date = new Date(v);
    const differenceInMs: number =
      Math.abs(date2.getTime() - date1.getTime());
    const millisecondsInDay: number = 1000 * 60 * 60 * 24;
    const differenceInDays: number =
      Math.floor(differenceInMs / millisecondsInDay);
    if (differenceInDays > 71) {
      let m = new Diff;
      m.Field = 'Formulated Decision Date vs Actual Transit Date';
      m.Formula = differenceInDays + ' > 71';
      m.NewData = this.datePipe.transform(this.releaseRequestForm.controls['TabThree'].get('TransitDate').value, "yyyy-MM-dd");
      this.diffsObjects.push(m);
    }
  }
  comparelastReceivedDocuments() {
    /*if (this.releaseRequestForm.controls['TabFour'].get('DateOfLastReceivedDocuments').value != null && this.releaseRequestForm.controls['TabFour'].get('DateOfLastReceivedDocuments').value != "") {
      let o = this.datePipe.transform(this.releaseRequestForm.controls['TabThree'].get('TransitDate').value, "yyyy-MM-dd");
      let x = this.datePipe.transform(this.releaseRequestForm.controls['TabFour'].get('DateOfLastReceivedDocuments').value, "yyyy-MM-dd");
      const date2: Date = new Date(o);
      const date1: Date = new Date(x);
      const oneYearInMillis = 365 * 24 * 60 * 60 * 1000; // One year in milliseconds
      const difference = Math.abs(date1.getTime() - date2.getTime());
      if (difference > oneYearInMillis) {
        let m = new Diff;
        m.Field = 'Voyage Certificates - Date of last received documents';
        m.Formula = '> one year';
        m.NewData = this.datePipe.transform(this.releaseRequestForm.controls['TabFour'].get('DateOfLastReceivedDocuments').value, "yyyy-MM-dd");
        this.diffsObjects.push(m);
      }
    }*/
  }
  compareSailingDate() {
    let o = this.datePipe.transform(this.releaseRequestForm.controls['TabOne'].get('BaseRequestCreationDate').value, "yyyy-MM-dd");
    let x = this.datePipe.transform(this.releaseRequestForm.controls['TabFour'].get('DocumnetedSailingDate').value, "yyyy-MM-dd");
    const date1: Date = new Date(o);
    const date2: Date = new Date(x);
    const timeDifference = Math.abs(date2.getTime() - date1.getTime());
    const dayDifference = timeDifference / (1000 * 60 * 60 * 24);
    if (dayDifference < 2) {
      let m = new Diff;
      m.Field = 'Voyage Certificates - sailing date';
      m.Formula = 'Sailing date - Creation date < 2 days';
      m.NewData = this.datePipe.transform(this.releaseRequestForm.controls['TabFour'].get('DocumnetedSailingDate').value, "yyyy-MM-dd");
      this.diffsObjects.push(m);
    }
  }
  compareSailingDateAIS() {
    let o = this.datePipe.transform(this.releaseRequestForm.controls['TabOne'].get('BaseRequestCreationDate').value, "yyyy-MM-dd");
    let x = this.datePipe.transform(this.releaseRequestForm.controls['TabFive'].get('AISSailingDate').value, "yyyy-MM-dd");
    const date1: Date = new Date(o);
    const date2: Date = new Date(x);
    const timeDifference = Math.abs(date2.getTime() - date1.getTime());
    const dayDifference = timeDifference / (1000 * 60 * 60 * 24);
    if (dayDifference < 2) {
      let m = new Diff;
      m.Field = 'Voyage Records  AIS -  AIS Sailing Date';
      m.Formula = 'AIS Sailing Date - Creation Date < 2 Days';
      m.NewData = this.datePipe.transform(this.releaseRequestForm.controls['TabFive'].get('AISSailingDate').value, "yyyy-MM-dd");
      this.diffsObjects.push(m);
    }

    let a = this.datePipe.transform(this.releaseRequestForm.controls['TabFour'].get('DocumnetedSailingDate').value, "yyyy-MM-dd");
    let b = this.datePipe.transform(this.releaseRequestForm.controls['TabFive'].get('AISSailingDate').value, "yyyy-MM-dd");
    const date3: Date = new Date(a);
    const date4: Date = new Date(b);

    if (date3.getTime() !== date4.getTime()) {
      let m = new Diff;
      m.Field = 'Voyage Records  AIS -  AIS Sailing Date';
      m.Formula = 'AIS Sailing Date != Documented Sailing Date';
      m.NewData = this.datePipe.transform(this.releaseRequestForm.controls['TabFive'].get('AISSailingDate').value, "yyyy-MM-dd");
      this.diffsObjects.push(m);
    }

  }
  compareStoppageDate(o, x, type) {

    const date1: Date = new Date(o);
    const date2: Date = new Date(x);
    const timeDifference = Math.abs(date2.getTime() - date1.getTime());
    const dayDifference = timeDifference / (1000 * 60 * 60 * 24);
    if (dayDifference > 6) {
      if (type == 'A') {
        let m = new Diff;
        m.Field = 'Voyage Records AIS - Stoppage end date';
        m.Formula = 'Stoppage end date - start date > 6 days';
        m.NewData = x;
        this.diffsObjects.push(m);
      }
      else {
        let m = new Diff;
        m.Field = 'Voyage Certificates - Stoppage end date';
        m.Formula = 'Stoppage end date - start date > 6 days';
        m.NewData = x;
        this.diffsObjects.push(m);
      }

    }
  }
  onTransitRateChange(id: number) {
    this.selectedRate = this.rates.find(i => i.Id == id);
  }
  onVesselTypeChange(id: number) {

    this.selectedvesselType = this.vesselTypes.find(i => i.Id == id);
  }
  onCircularChange(id: number) {
    this.selectedCircular = this.vesselTypes.find(i => i.Id == id);
  }
  onOriginPortChange() {
    this.releaseRequestForm.controls['TabFour'].patchValue({
      VoyageCertificatesOriginPort: this.releaseRequestForm.controls['TabTwo'].get('OriginPort').value,
    });
    this.releaseRequestForm.controls['TabFive'].patchValue({
      AISOriginPort: this.releaseRequestForm.controls['TabTwo'].get('OriginPort').value,
    });

  }
  onDestinationPortChange() {
    this.releaseRequestForm.controls['TabFour'].patchValue({
      VoyageCertificatesDestinationPort: this.releaseRequestForm.controls['TabTwo'].get('DestinationPort').value,
    });
    this.releaseRequestForm.controls['TabFive'].patchValue({
      AISDestinationPort: this.releaseRequestForm.controls['TabTwo'].get('DestinationPort').value,
    });

  }
  onRebatePercentageChange() {
    //this.releaseRequestForm.controls['TabThree'].patchValue({
    // TransitRebatePercentage: this.releaseRequestForm.controls['TabTwo'].get('RebatePercentage').value,
    // ActualRebatePercentage: this.releaseRequestForm.controls['TabTwo'].get('RebatePercentage').value,
    // });
  }
  loadCirculars(): void {
    this.lookupService.getCirculars().subscribe(
      data => this.circulars = data.Data as VesselType[],
      () => console.log("Something went wrong!!"),
    );
  }
  GetArabicNames(): void {
    this.longHaulService.GetArabicNames().subscribe(
      data => this.arabicNames = data.Data as ArabicNames[],
      () => console.log("Something went wrong!!"),
    );
  }
  loadVesselTypes(): void {
    this.lookupService.getVesselTypes().subscribe(
      data => this.vesselTypes = data.Data as VesselType[],
      () => console.log("Something went wrong!!"),
      () => this.loadVesselTypesCompleted()
    );
  }
  loadVesselTypesCompleted(): void {
    let otherVesselType: VesselType = this.vesselTypes.filter(v => v.NameEN == 'Other Vessel')[0];
    this.vesselTypes = this.vesselTypes.filter(v => v.NameEN != 'Other Vessel');
    this.vesselTypes.sort((a, b) => (a.NameEN > b.NameEN) ? 1 : -1);
    this.vesselTypes.push(otherVesselType);
  }
  loadRates(): void {
    this.lookupService.getRates().subscribe(
      data => this.rates = data.Data as GenericLookup[],
      () => console.log("Something went wrong!!"),

    );
  }
  loadPorts(): void {
    this.lookupService.getPorts().subscribe(
      data => this.ports = data.Data as Port[],
      () => console.log("Something went wrong!!"),
      () => this.loadPortsCompleted()
    );
  }
  loadPortsCompleted(): void {
    this.ports.sort((a, b) => (a.NameEN > b.NameEN) ? 1 : -1);
    //this.toastr.error('SSSSSSSSSSSS');
    this.loadRates();
    this.loadVesselTypes();

    this.getReleaseForm();

    //this.getNameByEmail('galal.mohamed@suezcanal.gov.eg')

  }
  navigaeToFirstInvalid(CurrentTabElementRef: ElementRef) {
    const invalidControls = CurrentTabElementRef.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidControls.length > 0) {
      for (let index = 0; index < invalidControls.length; index++) {
        const element = invalidControls[index];
        if (element.localName != "div") {
          element.focus();
          return;
        }
      }
    }
  }
  selectTab(tabId: number) {
    this.rebateRequestTabs.tabs[tabId].disabled = false;
    this.rebateRequestTabs.tabs[tabId].active = true;
    this.cd.detectChanges();
  }

  fillPortsDictionary(): void {
    for (let i: number = 0; i < this.longHaulRequestOptions.length; i++) {
      this.lastPortOriginsArr[i] = new OptionKey();
      this.lastPortOriginsArr[i].Index = i;
      this.lastPortOriginsArr[i].Text = this.ports.filter(p => p.Id == this.longHaulRequestOptions[i].LastPortOriginId)[0] != undefined ? this.ports.filter(p => p.Id == this.longHaulRequestOptions[i].LastPortOriginId)[0].NameEN : this.longHaulRequestOptions[i].OtherLastPortOrigin;
      this.lastPortOriginsArr[i].Value = this.longHaulRequestOptions[i].LastPortOriginId;
      this.firstPortDestinationsArr[i] = new OptionKey();
      this.firstPortDestinationsArr[i].Index = i;
      this.firstPortDestinationsArr[i].Text = this.ports.filter(p => p.Id == this.longHaulRequestOptions[i].FirstPortDestinationId)[0] != undefined ? this.ports.filter(p => p.Id == this.longHaulRequestOptions[i].FirstPortDestinationId)[0].NameEN : this.longHaulRequestOptions[i].OtherFirstPortDestination;
      this.firstPortDestinationsArr[i].Value = this.longHaulRequestOptions[i].LastPortOriginId;
    }
    this.releaseRequestForm.controls['TabTwo'].patchValue({

      Actualvoyage: this.Actualvoyage,



    });
  }
  get Validate2() {
    return this.noteAndReasons.controls;
  }
  get Validate() {
    return this.initiateworkflowForm.controls;
  }
  get workflowActionForm() {
    return this.WorkflowActionForm.controls;
  }
  OnInitiateWorkflow() {
    //this.isFormSubmitted = true;

    if (!this.isSubmitEnabled)
      this.isSubmitEnabled = true;

    this.globalServices.IsLoaderEnabled = true;
    switch (this.initiateworkflowForm.controls['selectinitiateworkflow'].value) {
      case "1":

        this.longHaulService.GetNextStepUsers('SCAServices_RefundFirstReviewer').subscribe(d => {
          this.selectedRows = [];
          this.initiateworkflowForm.get('Reason')?.clearValidators();
          this.initiateworkflowForm.get('Reason')?.setValue("");
          this.initiateworkflowForm.get('Reason')?.updateValueAndValidity();
          this.noteAndReasons.get('Reason')?.clearValidators();
          this.noteAndReasons.get('Reason')?.setValue("");
          this.noteAndReasons.get('Reason')?.updateValueAndValidity();
          this.isRestudy = false;
          this.showReason = false;
          this.showReasonCol = false;
          this.ListOfAdmins = d.Data;
          this.showML = true;
          this.isSubmitButtonDisplayed = true;
          this.globalServices.IsLoaderEnabled = false;

        });
        break;
      case "2":

        this.longHaulService.GetNextStepUsers('SCAServices_RestudyReviewer').subscribe(d => {
          this.initiateworkflowForm.controls['Reason'].setValidators([Validators.required]);
          this.initiateworkflowForm.controls['Reason'].updateValueAndValidity();
          this.noteAndReasons.controls['Reason'].setValidators([Validators.required]);
          this.noteAndReasons.controls['Reason'].updateValueAndValidity();

          this.isRestudy = true;
          this.showReason = true;
          this.ListOfAdmins = d.Data;
          this.showReasonCol = true;
          this.showML = true;
          this.isSubmitButtonDisplayed = true;
          this.globalServices.IsLoaderEnabled = false;
        });
        break;
      default:
        break;
    }
  }
  listChanged() {
    if (this.Validate.Admins && this.Validate.Admins.value != null) {
      this.selectedEmails = this.Validate.Admins.value.map(function (e) {
        return e.Email;
      });
    } else if (this.workflowActionForm.Admins && this.workflowActionForm.Admins.value != null) {
      this.selectedEmails = this.workflowActionForm.Admins.value.map(function (e) {
        return e.Email;
      });
    }
  }

  submit() {
    this.isFormSubmitted = true;
    if (this.initiateworkflowForm.valid && this.selectedEmails != null && this.selectedEmails.length != 0) {
      if (this.ReleaseFormId != "" && this.AdminEmail != "") {
        this.globalServices.IsLoaderEnabled = true;
        this.releaseFormStart.ReleaseRequestId = this.ReleaseFormId;
        this.releaseFormStart.AdminEmail = this.AdminEmail;
        // this.releaseFormStart.AdminId = this.AdminId;
        this.releaseFormStart.WFNextUsers = this.selectedEmails;
        this.releaseFormStart.Reason = this.initiateworkflowForm.controls['Reason'].value
        this.releaseFormStart.note = this.initiateworkflowForm.controls['Note'].value
        if (this.isRestudy) {
          this.StartRestudyWorkflow(this.releaseFormStart);
        }
        else {
          this.releaseFormStart.ActualRebateAmount = this.submitReleaseRequestResponseObject.Data.ActualRebateAmount;
          this.releaseFormStart.RebateAmountAsPerInvoice = this.submitReleaseRequestResponseObject.Data.RebateAmountAsPerInvoice;
          this.releaseFormStart.diffAmount = this.submitReleaseRequestResponseObject.Data.DiffAmount;
          this.releaseFormStart.ActualRebatePercentage = this.submitReleaseRequestResponseObject.Data.ActualRebatePercentage;
          this.StartRefundWorflow(this.releaseFormStart);
        }
      }
    }
  }
  StartRestudyWorkflow(releaseFormStart: ReleaseFormStartWFDTO) {

    this.longHaulService.StartRestudyWorkflow(releaseFormStart).subscribe(
      data => this.startWFObject = data,
      () => console.log("Something went wrong!!"),
      () => this.StarWorflowComplated()
    );
  }
  StartRefundWorflow(releaseFormStart: ReleaseFormStartWFDTO) {

    this.longHaulService.StartRefundWorflow(releaseFormStart).subscribe(
      data => this.startWFObject = data,
      () => console.log("Something went wrong!!"),
      () => this.StarWorflowComplated()
    );
  }
  StarWorflowComplated(): void {
    this.globalServices.IsLoaderEnabled = false;
    if (this.startWFObject.Success) {
      this.isFormValid = true;
      if (this.WorkflowActionForm.controls['workflowDecision'].value == 1 || this.WorkflowActionForm.controls['workflowDecision'].value == 3) {
        this.submitConfirmationMode = ConfirmationMode.WFContinueSuccess;
      } else if (this.WorkflowActionForm.controls['workflowDecision'].value == 2 || this.WorkflowActionForm.controls['workflowDecision'].value == 4) {
        this.submitConfirmationMode = ConfirmationMode.WFRecreationSuccess;
      } else {
        this.submitConfirmationMode = ConfirmationMode.Success;
      }
    }
    else {
      this.isFormValid = true;
      this.submitConfirmationMode = ConfirmationMode.Error;
    }
  }
  OnWorkflowDecision() {
    if (!this.isSubmitEnabled)
      this.isSubmitEnabled = true;

    this.globalServices.IsLoaderEnabled = true;
    if (this.WorkflowActionForm.controls['workflowDecision'].value == 1 || this.WorkflowActionForm.controls['workflowDecision'].value == 4) {
      this.longHaulService.GetNextStepUsers('SCAServices_RefundFirstReviewer').subscribe(d => {
        this.ListOfAdmins = d.Data;
        this.showML = true;
        this.selectedRows = [];
        this.initiateworkflowForm.get('Reason')?.clearValidators();
        this.initiateworkflowForm.get('Reason')?.setValue("");
        this.initiateworkflowForm.get('Reason')?.updateValueAndValidity();
        this.noteAndReasons.get('Reason')?.clearValidators();
        this.noteAndReasons.get('Reason')?.setValue("");
        this.noteAndReasons.get('Reason')?.updateValueAndValidity();


        this.isRestudy = false;
        this.showReason = false;
        this.showReasonCol = false;
        this.isWFSubmitButtonDisplayed = true;
        this.globalServices.IsLoaderEnabled = false;
      });
    } else {
      this.longHaulService.GetNextStepUsers('SCAServices_RestudyReviewer').subscribe(d => {
        this.ListOfAdmins = d.Data;
        this.showML = true;
        this.initiateworkflowForm.controls['Reason'].setValidators([Validators.required]);
        this.initiateworkflowForm.controls['Reason'].updateValueAndValidity();
        this.noteAndReasons.controls['Reason'].setValidators([Validators.required]);
        this.noteAndReasons.controls['Reason'].updateValueAndValidity();

        this.isRestudy = true;
        this.showReason = true;

        this.showReasonCol = true;

        this.isWFSubmitButtonDisplayed = true;
        this.globalServices.IsLoaderEnabled = false;
      });
    }
  }
  SubmitWorkflow() {

    this.isFormSubmitted = true;
    if (this.WorkflowActionForm.valid && this.selectedEmails != null && this.selectedEmails.length != 0) {
      if (this.ReleaseFormId != "" && this.AdminEmail != "") {
        this.globalServices.IsLoaderEnabled = true;
        if (this.WorkflowActionForm.controls['workflowDecision'].value == 1) {
          this.releaseFormStart.ReleaseRequestId = this.ReleaseFormId;
          this.releaseFormStart.AdminEmail = this.AdminEmail;
          // this.releaseFormStart.AdminId = this.AdminId;
          this.releaseFormStart.WFNextUsers = this.selectedEmails;
          this.releaseFormStart.ActualRebatePercentage = this.submitReleaseRequestResponseObject.Data.ActualRebatePercentage;
          this.releaseFormStart.ActualRebateAmount = this.submitReleaseRequestResponseObject.Data.ActualRebateAmount;
          this.releaseFormStart.RebateAmountAsPerInvoice = this.submitReleaseRequestResponseObject.Data.RebateAmountAsPerInvoice;
          this.releaseFormStart.IsWFExists = true;
          this.releaseFormStart.ExistWF = history.state.data.requestId;
          this.StartRefundWorflow(this.releaseFormStart);
        } else if (this.WorkflowActionForm.controls['workflowDecision'].value == 2) {
          this.releaseFormStart.ReleaseRequestId = this.ReleaseFormId;
          this.releaseFormStart.AdminEmail = this.AdminEmail;
          // this.releaseFormStart.AdminId = this.AdminId;
          this.releaseFormStart.WFNextUsers = this.selectedEmails;
          this.releaseFormStart.Reason = this.noteAndReasons.controls['Reason'].value;
          this.releaseFormStart.note = this.noteAndReasons.controls['Note'].value;
          this.releaseFormStart.ExistWF = history.state.data.requestId;
          this.releaseFormStart.WFToTerminate = history.state.data.requestId;
          this.StartRestudyWorkflow(this.releaseFormStart);
        } else if (this.WorkflowActionForm.controls['workflowDecision'].value == 3) {
          this.releaseFormStart.ReleaseRequestId = this.ReleaseFormId;
          this.releaseFormStart.AdminEmail = this.AdminEmail;
          // this.releaseFormStart.AdminId = this.AdminId;
          this.releaseFormStart.WFNextUsers = this.selectedEmails;
          this.releaseFormStart.IsWFExists = true;
          this.releaseFormStart.ExistWF = history.state.data.requestId;
          this.releaseFormStart.Reason = this.noteAndReasons.controls['Reason'].value;
          this.releaseFormStart.note = this.noteAndReasons.controls['Note'].value;
          this.StartRestudyWorkflow(this.releaseFormStart);
        } else {
          this.releaseFormStart.ReleaseRequestId = this.ReleaseFormId;
          this.releaseFormStart.AdminEmail = this.AdminEmail;
          // this.releaseFormStart.AdminId = this.AdminId;
          this.releaseFormStart.ActualRebatePercentage = this.submitReleaseRequestResponseObject.Data.ActualRebatePercentage;
          this.releaseFormStart.ActualRebateAmount = this.submitReleaseRequestResponseObject.Data.ActualRebateAmount;
          this.releaseFormStart.RebateAmountAsPerInvoice = this.submitReleaseRequestResponseObject.Data.RebateAmountAsPerInvoice;
          this.releaseFormStart.WFNextUsers = this.selectedEmails;
          this.releaseFormStart.ExistWF = history.state.data.requestId;
          this.releaseFormStart.WFToTerminate = history.state.data.requestId;
          this.StartRefundWorflow(this.releaseFormStart);
        }
      }
    }
  }
  rebateAmountChanged() {
    if (this.releaseRequestForm.controls['TabThree'].get('RebateAmountAsPerInvoice').value != "" && this.releaseRequestForm.controls['TabThree'].get('ActualRebateAmount').value != "") {
      this.releaseRequestForm.controls['TabThree'].get('DiffAmount').setValue(this.releaseRequestForm.controls['TabThree'].get('RebateAmountAsPerInvoice').value - this.releaseRequestForm.controls['TabThree'].get('ActualRebateAmount').value);
      this.releaseRequestForm.controls['TabThree'].get('DiffAmount').updateValueAndValidity();
    }
  }
}
//alaa
function ArabicAndEnglishTogether(text) {
  // Arabic Unicode range
  const hasArabic = /[\u0600-\u06FF]/.test(text);

  if (!hasArabic) {
    // English-only → return as-is
    return text;
  }

  // Mixed Arabic + English → apply your transformation
  return text
    .split(" ")
    .reverse()
    .join("\u0020")
    .split(" ")
    .reverse()
    .join("\u00A0")
    .replace(/([A-Za-z0-9%()]+)/g, w =>
      w.split("").reverse().join("")
    );
}
function hasArabic(text) {
  return /[\u0600-\u06FF]/.test(text);
}
enum ConfirmationMode {
  Success = 1,
  Error = 2,
  Alert = 3,
  WFContinueSuccess = 4,
  WFRecreationSuccess = 5
}
enum FormMode {
  New = 1,
  Edit = 2,
  Details = 3
}

